// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/audit.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../../google/protobuf/duration";
import { User } from "../../user/v1/user";
import { ActionInstance } from "../../policy/v1/policy";
import { ApprovalInstance } from "../../policy/v1/policy_steps_approval";
import { TaskAuditCancelledResult } from "../../app/v1/task";
import { TaskAuditErrorResult } from "../../app/v1/task";
import { TaskAuditSuccessResult } from "../../app/v1/task";
import { AccessRequestOutcome } from "./task";
import { RevokeOutcome } from "./task";
import { GrantOutcome } from "./task";
import { CertifyOutcome } from "./task";
import { TaskAction } from "./actions";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { TaskState } from "./task";
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditListRequest
 */
export interface TaskAuditListRequest {
    /**
     * @generated from protobuf field: string task_id = 1
     */
    taskId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskAuditViewRef refs = 4
     */
    refs: TaskAuditViewRef[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditListResponse
 */
export interface TaskAuditListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskAuditView list = 1
     */
    list: TaskAuditView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditView
 */
export interface TaskAuditView {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskState current_state = 3
     */
    currentState: TaskState;
    /**
     * @generated from protobuf field: int32 workflow_step = 4
     */
    workflowStep: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created = 5
     */
    created?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskAuditMetaData metadata = 6
     */
    metadata?: TaskAuditMetaData;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskAuditEventType event_type = 7
     */
    eventType: TaskAuditEventType;
    /**
     * @generated from protobuf field: c1.api.task.v1.Source source = 8
     */
    source: Source;
    /**
     * @generated from protobuf field: string ticket_id = 9
     */
    ticketId: string;
    /**
     * @generated from protobuf oneof: typ
     */
    typ: {
        oneofKind: "comment";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditComment comment = 100
         */
        comment: TaskAuditComment;
    } | {
        oneofKind: "stateChange";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditStateChange state_change = 101
         */
        stateChange: TaskAuditStateChange;
    } | {
        oneofKind: "approvalInstanceChange";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditApprovalInstanceChange approval_instance_change = 102
         */
        approvalInstanceChange: TaskAuditApprovalInstanceChange;
    } | {
        oneofKind: "connectorActionsStart";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditStartedConnectorActions connector_actions_start = 103
         */
        connectorActionsStart: TaskAuditStartedConnectorActions;
    } | {
        oneofKind: "connectorActionsEnd";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditFinishedConnectorActions connector_actions_end = 104
         */
        connectorActionsEnd: TaskAuditFinishedConnectorActions;
    } | {
        oneofKind: "actionResult";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditConnectorActionResult action_result = 105
         */
        actionResult: TaskAuditConnectorActionResult;
    } | {
        oneofKind: "taskCreated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditNewTask task_created = 106
         */
        taskCreated: TaskAuditNewTask;
    } | {
        oneofKind: "certifyOutcome";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditCertifyOutcome certify_outcome = 107
         */
        certifyOutcome: TaskAuditCertifyOutcome;
    } | {
        oneofKind: "actionSubmitted";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditActionSubmitted action_submitted = 108
         */
        actionSubmitted: TaskAuditActionSubmitted;
    } | {
        oneofKind: "grantOutcome";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditGrantOutcome grant_outcome = 109
         */
        grantOutcome: TaskAuditGrantOutcome;
    } | {
        oneofKind: "revokeOutcome";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditRevokeOutcome revoke_outcome = 110
         */
        revokeOutcome: TaskAuditRevokeOutcome;
    } | {
        oneofKind: "approvalReassigned";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyApprovalReassigned approval_reassigned = 111
         */
        approvalReassigned: TaskAuditPolicyApprovalReassigned;
    } | {
        oneofKind: "taskRestarted";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditRestart task_restarted = 112
         */
        taskRestarted: TaskAuditRestart;
    } | {
        oneofKind: "accessRequestOutcome";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditAccessRequestOutcome access_request_outcome = 113
         */
        accessRequestOutcome: TaskAuditAccessRequestOutcome;
    } | {
        oneofKind: "provisionReassigned";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyProvisionReassigned provision_reassigned = 114
         */
        provisionReassigned: TaskAuditPolicyProvisionReassigned;
    } | {
        oneofKind: "provisionError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyProvisionError provision_error = 115
         */
        provisionError: TaskAuditPolicyProvisionError;
    } | {
        oneofKind: "approvedAutomatically";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditApprovalHappenedAutomatically approved_automatically = 116
         */
        approvedAutomatically: TaskAuditApprovalHappenedAutomatically;
    } | {
        oneofKind: "reassignedToDelegate";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditReassignedToDelegate reassigned_to_delegate = 117
         */
        reassignedToDelegate: TaskAuditReassignedToDelegate;
    } | {
        oneofKind: "hardReset";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditHardReset hard_reset = 118
         */
        hardReset: TaskAuditHardReset;
    } | {
        oneofKind: "taskEscalated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditEscalateToEmergencyAccess task_escalated = 119
         */
        taskEscalated: TaskAuditEscalateToEmergencyAccess;
    } | {
        oneofKind: "conditionalPolicyExecutionResult";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditConditionalPolicyExecutionResult conditional_policy_execution_result = 120
         */
        conditionalPolicyExecutionResult: TaskAuditConditionalPolicyExecutionResult;
    } | {
        oneofKind: "expressionPolicyStepError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditExpressionPolicyStepError expression_policy_step_error = 121
         */
        expressionPolicyStepError: TaskAuditExpressionPolicyStepError;
    } | {
        oneofKind: "approvalAutoAcceptedByPolicy";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditApprovalAutoAcceptedByPolicy approval_auto_accepted_by_policy = 122
         */
        approvalAutoAcceptedByPolicy: TaskAuditApprovalAutoAcceptedByPolicy;
    } | {
        oneofKind: "approvalAutoRejectedByPolicy";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditApprovalAutoRejectedByPolicy approval_auto_rejected_by_policy = 123
         */
        approvalAutoRejectedByPolicy: TaskAuditApprovalAutoRejectedByPolicy;
    } | {
        oneofKind: "bulkActionError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditBulkActionError bulk_action_error = 124
         */
        bulkActionError: TaskAuditBulkActionError;
    } | {
        oneofKind: "webhookTriggered";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookTriggered webhook_triggered = 125
         */
        webhookTriggered: TaskAuditWebhookTriggered;
    } | {
        oneofKind: "webhookAttempt";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookAttempt webhook_attempt = 126
         */
        webhookAttempt: TaskAuditWebhookAttempt;
    } | {
        oneofKind: "webhookSuccess";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookSuccess webhook_success = 127
         */
        webhookSuccess: TaskAuditWebhookSuccess;
    } | {
        oneofKind: "policyEvaluationStep";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyEvaluationStep policy_evaluation_step = 128
         */
        policyEvaluationStep: TaskAuditPolicyEvaluationStep;
    } | {
        oneofKind: "waitStepSuccess";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitStepSuccess wait_step_success = 129
         */
        waitStepSuccess: TaskAuditWaitStepSuccess;
    } | {
        oneofKind: "waitStepWaiting";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitStepWaiting wait_step_waiting = 130
         */
        waitStepWaiting: TaskAuditWaitStepWaiting;
    } | {
        oneofKind: "waitStepTimedOut";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitStepTimedOut wait_step_timed_out = 131
         */
        waitStepTimedOut: TaskAuditWaitStepTimedOut;
    } | {
        oneofKind: "webhookApprovalTriggered";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookApprovalTriggered webhook_approval_triggered = 132
         */
        webhookApprovalTriggered: TaskAuditWebhookApprovalTriggered;
    } | {
        oneofKind: "webhookApprovalAttempt";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookApprovalAttempt webhook_approval_attempt = 133
         */
        webhookApprovalAttempt: TaskAuditWebhookApprovalAttempt;
    } | {
        oneofKind: "webhookApprovalSuccess";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookApprovalSuccess webhook_approval_success = 134
         */
        webhookApprovalSuccess: TaskAuditWebhookApprovalSuccess;
    } | {
        oneofKind: "webhookApprovalBadResponse";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookApprovalBadResponse webhook_approval_bad_response = 135
         */
        webhookApprovalBadResponse: TaskAuditWebhookApprovalBadResponse;
    } | {
        oneofKind: "externalTicketTriggered";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditExternalTicketTriggered external_ticket_triggered = 136
         */
        externalTicketTriggered: TaskAuditExternalTicketTriggered;
    } | {
        oneofKind: "externalTicketCreated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditExternalTicketCreated external_ticket_created = 137
         */
        externalTicketCreated: TaskAuditExternalTicketCreated;
    } | {
        oneofKind: "externalTicketError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditExternalTicketError external_ticket_error = 138
         */
        externalTicketError: TaskAuditExternalTicketError;
    } | {
        oneofKind: "waitStepAnalysisSuccess";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitForAnalysisStepSuccess wait_step_analysis_success = 139
         */
        waitStepAnalysisSuccess: TaskAuditWaitForAnalysisStepSuccess;
    } | {
        oneofKind: "waitStepAnalysisWaiting";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitForAnalysisStepWaiting wait_step_analysis_waiting = 140
         */
        waitStepAnalysisWaiting: TaskAuditWaitForAnalysisStepWaiting;
    } | {
        oneofKind: "waitStepAnalysisTimedOut";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitForAnalysisStepTimedOut wait_step_analysis_timed_out = 141
         */
        waitStepAnalysisTimedOut: TaskAuditWaitForAnalysisStepTimedOut;
    } | {
        oneofKind: "stepUpApproval";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditStepUpApproval step_up_approval = 142
         */
        stepUpApproval: TaskAuditStepUpApproval;
    } | {
        oneofKind: "externalTicketProvisionStepResolved";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditExternalTicketProvisionStepResolved external_ticket_provision_step_resolved = 143
         */
        externalTicketProvisionStepResolved: TaskAuditExternalTicketProvisionStepResolved;
    } | {
        oneofKind: "stepSkipped";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditStepSkipped step_skipped = 144
         */
        stepSkipped: TaskAuditStepSkipped;
    } | {
        oneofKind: "reassignmentListError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditReassignmentListError reassignment_list_error = 145
         */
        reassignmentListError: TaskAuditReassignmentListError;
    } | {
        oneofKind: "slaEscalation";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditSLAEscalation sla_escalation = 146
         */
        slaEscalation: TaskAuditSLAEscalation;
    } | {
        oneofKind: "policyChanged";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyChanged policy_changed = 147
         */
        policyChanged: TaskAuditPolicyChanged;
    } | {
        oneofKind: "formInstanceChange";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditFormInstanceChange form_instance_change = 148
         */
        formInstanceChange: TaskAuditFormInstanceChange;
    } | {
        oneofKind: "grantDurationUpdated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditGrantDurationUpdated grant_duration_updated = 149
         */
        grantDurationUpdated: TaskAuditGrantDurationUpdated;
    } | {
        oneofKind: "waitStepUntilTime";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitStepUntilTime wait_step_until_time = 150
         */
        waitStepUntilTime: TaskAuditWaitStepUntilTime;
    } | {
        oneofKind: "webhookApprovalFatalError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookApprovalFatalError webhook_approval_fatal_error = 151
         */
        webhookApprovalFatalError: TaskAuditWebhookApprovalFatalError;
    } | {
        oneofKind: "accountLifecycleActionCreated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditAccountLifecycleActionCreated account_lifecycle_action_created = 152
         */
        accountLifecycleActionCreated: TaskAuditAccountLifecycleActionCreated;
    } | {
        oneofKind: "accountLifecycleActionFailed";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditAccountLifecycleActionFailed account_lifecycle_action_failed = 153
         */
        accountLifecycleActionFailed: TaskAuditAccountLifecycleActionFailed;
    } | {
        oneofKind: "provisionCancelled";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyProvisionCancelled provision_cancelled = 154
         */
        provisionCancelled: TaskAuditPolicyProvisionCancelled;
    } | {
        oneofKind: "actionInstanceCreated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditActionInstanceCreated action_instance_created = 155
         */
        actionInstanceCreated: TaskAuditActionInstanceCreated;
    } | {
        oneofKind: "actionInstanceSucceeded";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditActionInstanceSucceeded action_instance_succeeded = 156
         */
        actionInstanceSucceeded: TaskAuditActionInstanceSucceeded;
    } | {
        oneofKind: "actionInstanceFailed";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditActionInstanceFailed action_instance_failed = 157
         */
        actionInstanceFailed: TaskAuditActionInstanceFailed;
    } | {
        oneofKind: "createdReplacementExtensionGrantTask";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditCreatedReplacementExtensionGrantTask created_replacement_extension_grant_task = 158
         */
        createdReplacementExtensionGrantTask: TaskAuditCreatedReplacementExtensionGrantTask;
    } | {
        oneofKind: "taskCreatedFrom";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditNewTaskCreatedFrom task_created_from = 159
         */
        taskCreatedFrom: TaskAuditNewTaskCreatedFrom;
    } | {
        oneofKind: "reassignmentFallbackToAdmin";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditReassignmentFallbackToAdmin reassignment_fallback_to_admin = 160
         */
        reassignmentFallbackToAdmin: TaskAuditReassignmentFallbackToAdmin;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditViewRef
 */
export interface TaskAuditViewRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditStepUpApproval
 */
export interface TaskAuditStepUpApproval {
    /**
     * @generated from protobuf field: string step_up_transaction_id = 1
     */
    stepUpTransactionId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditReassignmentListError
 */
export interface TaskAuditReassignmentListError {
    /**
     * @generated from protobuf field: string error_message = 1
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditStepSkipped
 */
export interface TaskAuditStepSkipped {
    /**
     * @generated from protobuf field: string skipped_by = 1
     */
    skippedBy: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditActionSubmitted
 */
export interface TaskAuditActionSubmitted {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskAction action = 1
     */
    action?: TaskAction;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditCertifyOutcome
 */
export interface TaskAuditCertifyOutcome {
    /**
     * @generated from protobuf field: c1.api.task.v1.CertifyOutcome outcome = 1
     */
    outcome: CertifyOutcome;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditGrantOutcome
 */
export interface TaskAuditGrantOutcome {
    /**
     * @generated from protobuf field: c1.api.task.v1.GrantOutcome outcome = 1
     */
    outcome: GrantOutcome;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditRevokeOutcome
 */
export interface TaskAuditRevokeOutcome {
    /**
     * @generated from protobuf field: c1.api.task.v1.RevokeOutcome outcome = 1
     */
    outcome: RevokeOutcome;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditAccessRequestOutcome
 */
export interface TaskAuditAccessRequestOutcome {
    /**
     * @generated from protobuf field: c1.api.task.v1.AccessRequestOutcome outcome = 1
     */
    outcome: AccessRequestOutcome;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditStartedConnectorActions
 */
export interface TaskAuditStartedConnectorActions {
    /**
     * @generated from protobuf field: string policy_step_id = 1
     */
    policyStepId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditFinishedConnectorActions
 */
export interface TaskAuditFinishedConnectorActions {
    /**
     * @generated from protobuf field: string policy_step_id = 1
     */
    policyStepId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditNewTask
 */
export interface TaskAuditNewTask {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditConnectorActionResult
 */
export interface TaskAuditConnectorActionResult {
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 5
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string connector_id = 6
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string connector_action_id = 7
     */
    connectorActionId: string;
    /**
     * @generated from protobuf oneof: result
     */
    result: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: c1.api.app.v1.TaskAuditSuccessResult success = 1
         */
        success: TaskAuditSuccessResult;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: c1.api.app.v1.TaskAuditErrorResult error = 2
         */
        error: TaskAuditErrorResult;
    } | {
        oneofKind: "cancelled";
        /**
         * @generated from protobuf field: c1.api.app.v1.TaskAuditCancelledResult cancelled = 3
         */
        cancelled: TaskAuditCancelledResult;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditComment
 */
export interface TaskAuditComment {
    /**
     * @generated from protobuf field: string comment = 1
     */
    comment: string;
    /**
     * @generated from protobuf field: string updated_by = 2
     */
    updatedBy: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditStateChange
 */
export interface TaskAuditStateChange {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskState previous_state = 4
     */
    previousState: TaskState;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditApprovalInstanceChange
 */
export interface TaskAuditApprovalInstanceChange {
    /**
     * @generated from protobuf field: c1.api.policy.v1.ApprovalInstance instance = 4
     */
    instance?: ApprovalInstance;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditActionInstanceCreated
 */
export interface TaskAuditActionInstanceCreated {
    /**
     * @generated from protobuf field: c1.api.policy.v1.ActionInstance instance = 1
     */
    instance?: ActionInstance;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditActionInstanceSucceeded
 */
export interface TaskAuditActionInstanceSucceeded {
    /**
     * @generated from protobuf field: c1.api.policy.v1.ActionInstance instance = 1
     */
    instance?: ActionInstance;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditActionInstanceFailed
 */
export interface TaskAuditActionInstanceFailed {
    /**
     * @generated from protobuf field: c1.api.policy.v1.ActionInstance instance = 1
     */
    instance?: ActionInstance;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditApprovalAutoAcceptedByPolicy
 */
export interface TaskAuditApprovalAutoAcceptedByPolicy {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditApprovalAutoRejectedByPolicy
 */
export interface TaskAuditApprovalAutoRejectedByPolicy {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditApprovalHappenedAutomatically
 */
export interface TaskAuditApprovalHappenedAutomatically {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditMetaData
 */
export interface TaskAuditMetaData {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 2
     */
    user?: User;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyApprovalReassigned
 */
export interface TaskAuditPolicyApprovalReassigned {
    /**
     * @generated from protobuf field: string old_policy_step_id = 1
     */
    oldPolicyStepId: string;
    /**
     * @generated from protobuf field: string new_policy_step_id = 2
     */
    newPolicyStepId: string;
    /**
     * @generated from protobuf field: repeated string new_users = 3
     */
    newUsers: string[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User users = 4
     */
    users: User[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyProvisionReassigned
 */
export interface TaskAuditPolicyProvisionReassigned {
    /**
     * @generated from protobuf field: string old_policy_step_id = 1
     */
    oldPolicyStepId: string;
    /**
     * @generated from protobuf field: string new_policy_step_id = 2
     */
    newPolicyStepId: string;
    /**
     * @generated from protobuf field: repeated string new_users = 3
     */
    newUsers: string[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User users = 4
     */
    users: User[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyProvisionError
 */
export interface TaskAuditPolicyProvisionError {
    /**
     * @generated from protobuf field: string error = 1
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditReassignedToDelegate
 */
export interface TaskAuditReassignedToDelegate {
    /**
     * @generated from protobuf field: string original_assignee_user_id = 1
     */
    originalAssigneeUserId: string;
    /**
     * @generated from protobuf field: string delegated_assignee_user_id = 2
     */
    delegatedAssigneeUserId: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.User original_assignee_user = 3
     */
    originalAssigneeUser?: User;
    /**
     * @generated from protobuf field: c1.api.user.v1.User delegated_assignee_user = 4
     */
    delegatedAssigneeUser?: User;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditRestart
 */
export interface TaskAuditRestart {
    /**
     * @generated from protobuf field: string old_policy_step_id = 1
     */
    oldPolicyStepId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditHardReset
 */
export interface TaskAuditHardReset {
    /**
     * @generated from protobuf field: string old_policy_step_id = 1
     */
    oldPolicyStepId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditEscalateToEmergencyAccess
 */
export interface TaskAuditEscalateToEmergencyAccess {
    /**
     * @generated from protobuf field: string old_policy_step_id = 1
     */
    oldPolicyStepId: string;
    /**
     * @generated from protobuf field: string old_policy_id = 2
     */
    oldPolicyId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditConditionalPolicyExecutionResult
 */
export interface TaskAuditConditionalPolicyExecutionResult {
    /**
     * @generated from protobuf field: string condition = 1
     */
    condition: string;
    /**
     * @generated from protobuf field: string policy_key = 2
     */
    policyKey: string;
    /**
     * @generated from protobuf field: bool condition_matched = 3
     */
    conditionMatched: boolean;
    /**
     * @generated from protobuf field: bool default_condition = 4
     */
    defaultCondition: boolean;
    /**
     * @generated from protobuf field: string error = 5
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditExpressionPolicyStepError
 */
export interface TaskAuditExpressionPolicyStepError {
    /**
     * @generated from protobuf field: string error = 1
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditBulkActionError
 */
export interface TaskAuditBulkActionError {
    /**
     * @generated from protobuf field: string error = 1
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditExternalTicketTriggered
 */
export interface TaskAuditExternalTicketTriggered {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 3
     */
    externalTicketProvisionerConfigId: string;
    /**
     * @generated from protobuf field: string external_ticket_id = 4
     */
    externalTicketId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_name = 5
     */
    externalTicketProvisionerConfigName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditExternalTicketCreated
 */
export interface TaskAuditExternalTicketCreated {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 3
     */
    externalTicketProvisionerConfigId: string;
    /**
     * @generated from protobuf field: string external_ticket_id = 4
     */
    externalTicketId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_name = 5
     */
    externalTicketProvisionerConfigName: string;
    /**
     * @generated from protobuf field: string external_ticket_url = 6
     */
    externalTicketUrl: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditExternalTicketProvisionStepResolved
 */
export interface TaskAuditExternalTicketProvisionStepResolved {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 3
     */
    externalTicketProvisionerConfigId: string;
    /**
     * @generated from protobuf field: string external_ticket_id = 4
     */
    externalTicketId: string;
    /**
     * @generated from protobuf field: string external_ticket_url = 5
     */
    externalTicketUrl: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditExternalTicketError
 */
export interface TaskAuditExternalTicketError {
    /**
     * @generated from protobuf field: string error_message = 1
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookTriggered
 */
export interface TaskAuditWebhookTriggered {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookAttempt
 */
export interface TaskAuditWebhookAttempt {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookSuccess
 */
export interface TaskAuditWebhookSuccess {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookApprovalTriggered
 */
export interface TaskAuditWebhookApprovalTriggered {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookApprovalAttempt
 */
export interface TaskAuditWebhookApprovalAttempt {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookApprovalSuccess
 */
export interface TaskAuditWebhookApprovalSuccess {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookApprovalBadResponse
 */
export interface TaskAuditWebhookApprovalBadResponse {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4
     */
    webhookName: string;
    /**
     * @generated from protobuf field: string error = 5
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookApprovalFatalError
 */
export interface TaskAuditWebhookApprovalFatalError {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4
     */
    webhookName: string;
    /**
     * @generated from protobuf field: string error = 5
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyEvaluationStep
 */
export interface TaskAuditPolicyEvaluationStep {
    /**
     * @generated from protobuf field: string step_comment = 1
     */
    stepComment: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitStepSuccess
 */
export interface TaskAuditWaitStepSuccess {
    /**
     * @generated from protobuf field: string step_id = 1
     */
    stepId: string;
    /**
     * @generated from protobuf field: string condition = 2
     */
    condition: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp succeeded_at = 3
     */
    succeededAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitStepWaiting
 */
export interface TaskAuditWaitStepWaiting {
    /**
     * @generated from protobuf field: string step_id = 1
     */
    stepId: string;
    /**
     * @generated from protobuf field: string condition = 2
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitStepTimedOut
 */
export interface TaskAuditWaitStepTimedOut {
    /**
     * @generated from protobuf field: string step_id = 1
     */
    stepId: string;
    /**
     * @generated from protobuf field: string condition = 2
     */
    condition: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timed_out_at = 3
     */
    timedOutAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepSuccess
 */
export interface TaskAuditWaitForAnalysisStepSuccess {
    /**
     * @generated from protobuf field: string step_id = 1
     */
    stepId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp succeeded_at = 3
     */
    succeededAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepWaiting
 */
export interface TaskAuditWaitForAnalysisStepWaiting {
    /**
     * @generated from protobuf field: string step_id = 1
     */
    stepId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepTimedOut
 */
export interface TaskAuditWaitForAnalysisStepTimedOut {
    /**
     * @generated from protobuf field: string step_id = 1
     */
    stepId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timed_out_at = 3
     */
    timedOutAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditSLAEscalation
 */
export interface TaskAuditSLAEscalation {
    /**
     * @generated from protobuf field: string message = 1
     */
    message: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyChanged
 */
export interface TaskAuditPolicyChanged {
    /**
     * @generated from protobuf field: string old_policy_id = 1
     */
    oldPolicyId: string;
    /**
     * @generated from protobuf field: string new_policy_id = 2
     */
    newPolicyId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditFormInstanceChange
 */
export interface TaskAuditFormInstanceChange {
    /**
     * @generated from protobuf field: bool is_valid = 1
     */
    isValid: boolean;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditGrantDurationUpdated
 */
export interface TaskAuditGrantDurationUpdated {
    /**
     * @generated from protobuf field: google.protobuf.Duration duration = 1
     */
    duration?: Duration;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitStepUntilTime
 */
export interface TaskAuditWaitStepUntilTime {
    /**
     * @generated from protobuf field: string step_id = 1
     */
    stepId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp until_time = 2
     */
    untilTime?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditAccountLifecycleActionCreated
 */
export interface TaskAuditAccountLifecycleActionCreated {
    /**
     * @generated from protobuf field: string baton_action_invocation_id = 1
     */
    batonActionInvocationId: string;
    /**
     * @generated from protobuf field: string baton_action_name = 2
     */
    batonActionName: string;
    /**
     * @generated from protobuf field: string baton_connector_id = 3
     */
    batonConnectorId: string;
    /**
     * @generated from protobuf field: string baton_app_id = 4
     */
    batonAppId: string;
    /**
     * @generated from protobuf field: string baton_action_display_name = 5
     */
    batonActionDisplayName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditAccountLifecycleActionFailed
 */
export interface TaskAuditAccountLifecycleActionFailed {
    /**
     * @generated from protobuf field: string baton_action_invocation_id = 1
     */
    batonActionInvocationId: string;
    /**
     * @generated from protobuf field: string baton_action_name = 2
     */
    batonActionName: string;
    /**
     * @generated from protobuf field: string baton_connector_id = 3
     */
    batonConnectorId: string;
    /**
     * @generated from protobuf field: string baton_app_id = 4
     */
    batonAppId: string;
    /**
     * @generated from protobuf field: string baton_action_display_name = 5
     */
    batonActionDisplayName: string;
    /**
     * @generated from protobuf field: string error = 6
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyProvisionCancelled
 */
export interface TaskAuditPolicyProvisionCancelled {
    /**
     * @generated from protobuf field: string cancel_reason = 1
     */
    cancelReason: string;
}
/**
 * TaskAuditCreatedReplacementExtensionGrantTask is used when a replacement extension grant task is created
 * (e.g. when an extension grant task is cancelled due to app user deletion).
 *
 * @generated from protobuf message c1.api.task.v1.TaskAuditCreatedReplacementExtensionGrantTask
 */
export interface TaskAuditCreatedReplacementExtensionGrantTask {
    /**
     * The ID of the newly created replacement task
     *
     * @generated from protobuf field: string new_task_id = 1
     */
    newTaskId: string;
    /**
     * The numeric ID of the newly created replacement task (for display)
     *
     * @generated from protobuf field: int64 new_task_numeric_id = 2
     */
    newTaskNumericId: number;
}
/**
 * TaskAuditNewTaskCreatedFrom is used when a task is created from another task
 * (e.g. when a replacement extension grant task is created after the original is cancelled).
 * This is set on the NEW task to indicate its origin.
 *
 * @generated from protobuf message c1.api.task.v1.TaskAuditNewTaskCreatedFrom
 */
export interface TaskAuditNewTaskCreatedFrom {
    /**
     * @generated from protobuf field: string original_task_id = 1
     */
    originalTaskId: string;
    /**
     * @generated from protobuf field: int64 original_task_numeric_id = 2
     */
    originalTaskNumericId: number;
}
/**
 * TaskAuditReassignmentFallbackToAdmin is used when no eligible reviewers are found
 * from the policy configuration and the task falls back to system administrators
 * without creating a new policy step. This prevents reassignment loops.
 *
 * @generated from protobuf message c1.api.task.v1.TaskAuditReassignmentFallbackToAdmin
 */
export interface TaskAuditReassignmentFallbackToAdmin {
    /**
     * The IDs of the system administrator users that the task is being assigned to
     *
     * @generated from protobuf field: repeated string admin_user_ids = 1
     */
    adminUserIds: string[];
    /**
     * The system administrator users (populated for display)
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User admin_users = 2
     */
    adminUsers: User[];
}
/**
 * @generated from protobuf enum c1.api.task.v1.Source
 */
export enum Source {
    /**
     * @generated from protobuf enum value: SOURCE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SOURCE_C1 = 1;
     */
    C1 = 1,
    /**
     * @generated from protobuf enum value: SOURCE_JIRA = 2;
     */
    JIRA = 2,
    /**
     * @generated from protobuf enum value: SOURCE_SLACK = 3;
     */
    SLACK = 3,
    /**
     * @generated from protobuf enum value: SOURCE_COPILOT_AGENTS = 4;
     */
    COPILOT_AGENTS = 4
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskAuditEventType
 */
export enum TaskAuditEventType {
    /**
     * @generated from protobuf enum value: TASK_AUDIT_EVENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_AUDIT_EVENT_TYPE_NEUTRAL = 1;
     */
    NEUTRAL = 1,
    /**
     * @generated from protobuf enum value: TASK_AUDIT_EVENT_TYPE_ERROR = 2;
     */
    ERROR = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditListRequest$Type extends MessageType<TaskAuditListRequest> {
    constructor() {
        super("c1.api.task.v1.TaskAuditListRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskAuditViewRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<TaskAuditListRequest>): TaskAuditListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<TaskAuditListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditListRequest): TaskAuditListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string task_id */ 1:
                    message.taskId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.task.v1.TaskAuditViewRef refs */ 4:
                    message.refs.push(TaskAuditViewRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string task_id = 1; */
        if (message.taskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.taskId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.task.v1.TaskAuditViewRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            TaskAuditViewRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditListRequest
 */
export const TaskAuditListRequest = new TaskAuditListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditListResponse$Type extends MessageType<TaskAuditListResponse> {
    constructor() {
        super("c1.api.task.v1.TaskAuditListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskAuditView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditListResponse>): TaskAuditListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditListResponse): TaskAuditListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskAuditView list */ 1:
                    message.list.push(TaskAuditView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskAuditView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TaskAuditView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditListResponse
 */
export const TaskAuditListResponse = new TaskAuditListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditView$Type extends MessageType<TaskAuditView> {
    constructor() {
        super("c1.api.task.v1.TaskAuditView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_state", kind: "enum", T: () => ["c1.api.task.v1.TaskState", TaskState, "TASK_STATE_"] },
            { no: 4, name: "workflow_step", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created", kind: "message", T: () => Timestamp },
            { no: 6, name: "metadata", kind: "message", T: () => TaskAuditMetaData },
            { no: 7, name: "event_type", kind: "enum", T: () => ["c1.api.task.v1.TaskAuditEventType", TaskAuditEventType, "TASK_AUDIT_EVENT_TYPE_"] },
            { no: 8, name: "source", kind: "enum", T: () => ["c1.api.task.v1.Source", Source, "SOURCE_"] },
            { no: 9, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "comment", kind: "message", oneof: "typ", T: () => TaskAuditComment },
            { no: 101, name: "state_change", kind: "message", oneof: "typ", T: () => TaskAuditStateChange },
            { no: 102, name: "approval_instance_change", kind: "message", oneof: "typ", T: () => TaskAuditApprovalInstanceChange },
            { no: 103, name: "connector_actions_start", kind: "message", oneof: "typ", T: () => TaskAuditStartedConnectorActions },
            { no: 104, name: "connector_actions_end", kind: "message", oneof: "typ", T: () => TaskAuditFinishedConnectorActions },
            { no: 105, name: "action_result", kind: "message", oneof: "typ", T: () => TaskAuditConnectorActionResult },
            { no: 106, name: "task_created", kind: "message", oneof: "typ", T: () => TaskAuditNewTask },
            { no: 107, name: "certify_outcome", kind: "message", oneof: "typ", T: () => TaskAuditCertifyOutcome },
            { no: 108, name: "action_submitted", kind: "message", oneof: "typ", T: () => TaskAuditActionSubmitted },
            { no: 109, name: "grant_outcome", kind: "message", oneof: "typ", T: () => TaskAuditGrantOutcome },
            { no: 110, name: "revoke_outcome", kind: "message", oneof: "typ", T: () => TaskAuditRevokeOutcome },
            { no: 111, name: "approval_reassigned", kind: "message", oneof: "typ", T: () => TaskAuditPolicyApprovalReassigned },
            { no: 112, name: "task_restarted", kind: "message", oneof: "typ", T: () => TaskAuditRestart },
            { no: 113, name: "access_request_outcome", kind: "message", oneof: "typ", T: () => TaskAuditAccessRequestOutcome },
            { no: 114, name: "provision_reassigned", kind: "message", oneof: "typ", T: () => TaskAuditPolicyProvisionReassigned },
            { no: 115, name: "provision_error", kind: "message", oneof: "typ", T: () => TaskAuditPolicyProvisionError },
            { no: 116, name: "approved_automatically", kind: "message", oneof: "typ", T: () => TaskAuditApprovalHappenedAutomatically },
            { no: 117, name: "reassigned_to_delegate", kind: "message", oneof: "typ", T: () => TaskAuditReassignedToDelegate },
            { no: 118, name: "hard_reset", kind: "message", oneof: "typ", T: () => TaskAuditHardReset },
            { no: 119, name: "task_escalated", kind: "message", oneof: "typ", T: () => TaskAuditEscalateToEmergencyAccess },
            { no: 120, name: "conditional_policy_execution_result", kind: "message", oneof: "typ", T: () => TaskAuditConditionalPolicyExecutionResult },
            { no: 121, name: "expression_policy_step_error", kind: "message", oneof: "typ", T: () => TaskAuditExpressionPolicyStepError },
            { no: 122, name: "approval_auto_accepted_by_policy", kind: "message", oneof: "typ", T: () => TaskAuditApprovalAutoAcceptedByPolicy },
            { no: 123, name: "approval_auto_rejected_by_policy", kind: "message", oneof: "typ", T: () => TaskAuditApprovalAutoRejectedByPolicy },
            { no: 124, name: "bulk_action_error", kind: "message", oneof: "typ", T: () => TaskAuditBulkActionError },
            { no: 125, name: "webhook_triggered", kind: "message", oneof: "typ", T: () => TaskAuditWebhookTriggered },
            { no: 126, name: "webhook_attempt", kind: "message", oneof: "typ", T: () => TaskAuditWebhookAttempt },
            { no: 127, name: "webhook_success", kind: "message", oneof: "typ", T: () => TaskAuditWebhookSuccess },
            { no: 128, name: "policy_evaluation_step", kind: "message", oneof: "typ", T: () => TaskAuditPolicyEvaluationStep },
            { no: 129, name: "wait_step_success", kind: "message", oneof: "typ", T: () => TaskAuditWaitStepSuccess },
            { no: 130, name: "wait_step_waiting", kind: "message", oneof: "typ", T: () => TaskAuditWaitStepWaiting },
            { no: 131, name: "wait_step_timed_out", kind: "message", oneof: "typ", T: () => TaskAuditWaitStepTimedOut },
            { no: 132, name: "webhook_approval_triggered", kind: "message", oneof: "typ", T: () => TaskAuditWebhookApprovalTriggered },
            { no: 133, name: "webhook_approval_attempt", kind: "message", oneof: "typ", T: () => TaskAuditWebhookApprovalAttempt },
            { no: 134, name: "webhook_approval_success", kind: "message", oneof: "typ", T: () => TaskAuditWebhookApprovalSuccess },
            { no: 135, name: "webhook_approval_bad_response", kind: "message", oneof: "typ", T: () => TaskAuditWebhookApprovalBadResponse },
            { no: 136, name: "external_ticket_triggered", kind: "message", oneof: "typ", T: () => TaskAuditExternalTicketTriggered },
            { no: 137, name: "external_ticket_created", kind: "message", oneof: "typ", T: () => TaskAuditExternalTicketCreated },
            { no: 138, name: "external_ticket_error", kind: "message", oneof: "typ", T: () => TaskAuditExternalTicketError },
            { no: 139, name: "wait_step_analysis_success", kind: "message", oneof: "typ", T: () => TaskAuditWaitForAnalysisStepSuccess },
            { no: 140, name: "wait_step_analysis_waiting", kind: "message", oneof: "typ", T: () => TaskAuditWaitForAnalysisStepWaiting },
            { no: 141, name: "wait_step_analysis_timed_out", kind: "message", oneof: "typ", T: () => TaskAuditWaitForAnalysisStepTimedOut },
            { no: 142, name: "step_up_approval", kind: "message", oneof: "typ", T: () => TaskAuditStepUpApproval },
            { no: 143, name: "external_ticket_provision_step_resolved", kind: "message", oneof: "typ", T: () => TaskAuditExternalTicketProvisionStepResolved },
            { no: 144, name: "step_skipped", kind: "message", oneof: "typ", T: () => TaskAuditStepSkipped },
            { no: 145, name: "reassignment_list_error", kind: "message", oneof: "typ", T: () => TaskAuditReassignmentListError },
            { no: 146, name: "sla_escalation", kind: "message", oneof: "typ", T: () => TaskAuditSLAEscalation },
            { no: 147, name: "policy_changed", kind: "message", oneof: "typ", T: () => TaskAuditPolicyChanged },
            { no: 148, name: "form_instance_change", kind: "message", oneof: "typ", T: () => TaskAuditFormInstanceChange },
            { no: 149, name: "grant_duration_updated", kind: "message", oneof: "typ", T: () => TaskAuditGrantDurationUpdated },
            { no: 150, name: "wait_step_until_time", kind: "message", oneof: "typ", T: () => TaskAuditWaitStepUntilTime },
            { no: 151, name: "webhook_approval_fatal_error", kind: "message", oneof: "typ", T: () => TaskAuditWebhookApprovalFatalError },
            { no: 152, name: "account_lifecycle_action_created", kind: "message", oneof: "typ", T: () => TaskAuditAccountLifecycleActionCreated },
            { no: 153, name: "account_lifecycle_action_failed", kind: "message", oneof: "typ", T: () => TaskAuditAccountLifecycleActionFailed },
            { no: 154, name: "provision_cancelled", kind: "message", oneof: "typ", T: () => TaskAuditPolicyProvisionCancelled },
            { no: 155, name: "action_instance_created", kind: "message", oneof: "typ", T: () => TaskAuditActionInstanceCreated },
            { no: 156, name: "action_instance_succeeded", kind: "message", oneof: "typ", T: () => TaskAuditActionInstanceSucceeded },
            { no: 157, name: "action_instance_failed", kind: "message", oneof: "typ", T: () => TaskAuditActionInstanceFailed },
            { no: 158, name: "created_replacement_extension_grant_task", kind: "message", oneof: "typ", T: () => TaskAuditCreatedReplacementExtensionGrantTask },
            { no: 159, name: "task_created_from", kind: "message", oneof: "typ", T: () => TaskAuditNewTaskCreatedFrom },
            { no: 160, name: "reassignment_fallback_to_admin", kind: "message", oneof: "typ", T: () => TaskAuditReassignmentFallbackToAdmin }
        ]);
    }
    create(value?: PartialMessage<TaskAuditView>): TaskAuditView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.userId = "";
        message.currentState = 0;
        message.workflowStep = 0;
        message.eventType = 0;
        message.source = 0;
        message.ticketId = "";
        message.typ = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<TaskAuditView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditView): TaskAuditView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskState current_state */ 3:
                    message.currentState = reader.int32();
                    break;
                case /* int32 workflow_step */ 4:
                    message.workflowStep = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created */ 5:
                    message.created = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.created);
                    break;
                case /* c1.api.task.v1.TaskAuditMetaData metadata */ 6:
                    message.metadata = TaskAuditMetaData.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                case /* c1.api.task.v1.TaskAuditEventType event_type */ 7:
                    message.eventType = reader.int32();
                    break;
                case /* c1.api.task.v1.Source source */ 8:
                    message.source = reader.int32();
                    break;
                case /* string ticket_id */ 9:
                    message.ticketId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskAuditComment comment */ 100:
                    message.typ = {
                        oneofKind: "comment",
                        comment: TaskAuditComment.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).comment)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditStateChange state_change */ 101:
                    message.typ = {
                        oneofKind: "stateChange",
                        stateChange: TaskAuditStateChange.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).stateChange)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditApprovalInstanceChange approval_instance_change */ 102:
                    message.typ = {
                        oneofKind: "approvalInstanceChange",
                        approvalInstanceChange: TaskAuditApprovalInstanceChange.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).approvalInstanceChange)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditStartedConnectorActions connector_actions_start */ 103:
                    message.typ = {
                        oneofKind: "connectorActionsStart",
                        connectorActionsStart: TaskAuditStartedConnectorActions.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).connectorActionsStart)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditFinishedConnectorActions connector_actions_end */ 104:
                    message.typ = {
                        oneofKind: "connectorActionsEnd",
                        connectorActionsEnd: TaskAuditFinishedConnectorActions.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).connectorActionsEnd)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditConnectorActionResult action_result */ 105:
                    message.typ = {
                        oneofKind: "actionResult",
                        actionResult: TaskAuditConnectorActionResult.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).actionResult)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditNewTask task_created */ 106:
                    message.typ = {
                        oneofKind: "taskCreated",
                        taskCreated: TaskAuditNewTask.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).taskCreated)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditCertifyOutcome certify_outcome */ 107:
                    message.typ = {
                        oneofKind: "certifyOutcome",
                        certifyOutcome: TaskAuditCertifyOutcome.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).certifyOutcome)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditActionSubmitted action_submitted */ 108:
                    message.typ = {
                        oneofKind: "actionSubmitted",
                        actionSubmitted: TaskAuditActionSubmitted.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).actionSubmitted)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditGrantOutcome grant_outcome */ 109:
                    message.typ = {
                        oneofKind: "grantOutcome",
                        grantOutcome: TaskAuditGrantOutcome.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).grantOutcome)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditRevokeOutcome revoke_outcome */ 110:
                    message.typ = {
                        oneofKind: "revokeOutcome",
                        revokeOutcome: TaskAuditRevokeOutcome.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).revokeOutcome)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditPolicyApprovalReassigned approval_reassigned */ 111:
                    message.typ = {
                        oneofKind: "approvalReassigned",
                        approvalReassigned: TaskAuditPolicyApprovalReassigned.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).approvalReassigned)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditRestart task_restarted */ 112:
                    message.typ = {
                        oneofKind: "taskRestarted",
                        taskRestarted: TaskAuditRestart.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).taskRestarted)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditAccessRequestOutcome access_request_outcome */ 113:
                    message.typ = {
                        oneofKind: "accessRequestOutcome",
                        accessRequestOutcome: TaskAuditAccessRequestOutcome.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).accessRequestOutcome)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditPolicyProvisionReassigned provision_reassigned */ 114:
                    message.typ = {
                        oneofKind: "provisionReassigned",
                        provisionReassigned: TaskAuditPolicyProvisionReassigned.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).provisionReassigned)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditPolicyProvisionError provision_error */ 115:
                    message.typ = {
                        oneofKind: "provisionError",
                        provisionError: TaskAuditPolicyProvisionError.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).provisionError)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditApprovalHappenedAutomatically approved_automatically */ 116:
                    message.typ = {
                        oneofKind: "approvedAutomatically",
                        approvedAutomatically: TaskAuditApprovalHappenedAutomatically.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).approvedAutomatically)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditReassignedToDelegate reassigned_to_delegate */ 117:
                    message.typ = {
                        oneofKind: "reassignedToDelegate",
                        reassignedToDelegate: TaskAuditReassignedToDelegate.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).reassignedToDelegate)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditHardReset hard_reset */ 118:
                    message.typ = {
                        oneofKind: "hardReset",
                        hardReset: TaskAuditHardReset.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).hardReset)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditEscalateToEmergencyAccess task_escalated */ 119:
                    message.typ = {
                        oneofKind: "taskEscalated",
                        taskEscalated: TaskAuditEscalateToEmergencyAccess.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).taskEscalated)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditConditionalPolicyExecutionResult conditional_policy_execution_result */ 120:
                    message.typ = {
                        oneofKind: "conditionalPolicyExecutionResult",
                        conditionalPolicyExecutionResult: TaskAuditConditionalPolicyExecutionResult.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).conditionalPolicyExecutionResult)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditExpressionPolicyStepError expression_policy_step_error */ 121:
                    message.typ = {
                        oneofKind: "expressionPolicyStepError",
                        expressionPolicyStepError: TaskAuditExpressionPolicyStepError.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).expressionPolicyStepError)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditApprovalAutoAcceptedByPolicy approval_auto_accepted_by_policy */ 122:
                    message.typ = {
                        oneofKind: "approvalAutoAcceptedByPolicy",
                        approvalAutoAcceptedByPolicy: TaskAuditApprovalAutoAcceptedByPolicy.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).approvalAutoAcceptedByPolicy)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditApprovalAutoRejectedByPolicy approval_auto_rejected_by_policy */ 123:
                    message.typ = {
                        oneofKind: "approvalAutoRejectedByPolicy",
                        approvalAutoRejectedByPolicy: TaskAuditApprovalAutoRejectedByPolicy.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).approvalAutoRejectedByPolicy)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditBulkActionError bulk_action_error */ 124:
                    message.typ = {
                        oneofKind: "bulkActionError",
                        bulkActionError: TaskAuditBulkActionError.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).bulkActionError)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWebhookTriggered webhook_triggered */ 125:
                    message.typ = {
                        oneofKind: "webhookTriggered",
                        webhookTriggered: TaskAuditWebhookTriggered.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).webhookTriggered)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWebhookAttempt webhook_attempt */ 126:
                    message.typ = {
                        oneofKind: "webhookAttempt",
                        webhookAttempt: TaskAuditWebhookAttempt.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).webhookAttempt)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWebhookSuccess webhook_success */ 127:
                    message.typ = {
                        oneofKind: "webhookSuccess",
                        webhookSuccess: TaskAuditWebhookSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).webhookSuccess)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditPolicyEvaluationStep policy_evaluation_step */ 128:
                    message.typ = {
                        oneofKind: "policyEvaluationStep",
                        policyEvaluationStep: TaskAuditPolicyEvaluationStep.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).policyEvaluationStep)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWaitStepSuccess wait_step_success */ 129:
                    message.typ = {
                        oneofKind: "waitStepSuccess",
                        waitStepSuccess: TaskAuditWaitStepSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).waitStepSuccess)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWaitStepWaiting wait_step_waiting */ 130:
                    message.typ = {
                        oneofKind: "waitStepWaiting",
                        waitStepWaiting: TaskAuditWaitStepWaiting.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).waitStepWaiting)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWaitStepTimedOut wait_step_timed_out */ 131:
                    message.typ = {
                        oneofKind: "waitStepTimedOut",
                        waitStepTimedOut: TaskAuditWaitStepTimedOut.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).waitStepTimedOut)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWebhookApprovalTriggered webhook_approval_triggered */ 132:
                    message.typ = {
                        oneofKind: "webhookApprovalTriggered",
                        webhookApprovalTriggered: TaskAuditWebhookApprovalTriggered.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).webhookApprovalTriggered)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWebhookApprovalAttempt webhook_approval_attempt */ 133:
                    message.typ = {
                        oneofKind: "webhookApprovalAttempt",
                        webhookApprovalAttempt: TaskAuditWebhookApprovalAttempt.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).webhookApprovalAttempt)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWebhookApprovalSuccess webhook_approval_success */ 134:
                    message.typ = {
                        oneofKind: "webhookApprovalSuccess",
                        webhookApprovalSuccess: TaskAuditWebhookApprovalSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).webhookApprovalSuccess)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWebhookApprovalBadResponse webhook_approval_bad_response */ 135:
                    message.typ = {
                        oneofKind: "webhookApprovalBadResponse",
                        webhookApprovalBadResponse: TaskAuditWebhookApprovalBadResponse.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).webhookApprovalBadResponse)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditExternalTicketTriggered external_ticket_triggered */ 136:
                    message.typ = {
                        oneofKind: "externalTicketTriggered",
                        externalTicketTriggered: TaskAuditExternalTicketTriggered.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).externalTicketTriggered)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditExternalTicketCreated external_ticket_created */ 137:
                    message.typ = {
                        oneofKind: "externalTicketCreated",
                        externalTicketCreated: TaskAuditExternalTicketCreated.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).externalTicketCreated)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditExternalTicketError external_ticket_error */ 138:
                    message.typ = {
                        oneofKind: "externalTicketError",
                        externalTicketError: TaskAuditExternalTicketError.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).externalTicketError)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWaitForAnalysisStepSuccess wait_step_analysis_success */ 139:
                    message.typ = {
                        oneofKind: "waitStepAnalysisSuccess",
                        waitStepAnalysisSuccess: TaskAuditWaitForAnalysisStepSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).waitStepAnalysisSuccess)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWaitForAnalysisStepWaiting wait_step_analysis_waiting */ 140:
                    message.typ = {
                        oneofKind: "waitStepAnalysisWaiting",
                        waitStepAnalysisWaiting: TaskAuditWaitForAnalysisStepWaiting.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).waitStepAnalysisWaiting)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWaitForAnalysisStepTimedOut wait_step_analysis_timed_out */ 141:
                    message.typ = {
                        oneofKind: "waitStepAnalysisTimedOut",
                        waitStepAnalysisTimedOut: TaskAuditWaitForAnalysisStepTimedOut.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).waitStepAnalysisTimedOut)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditStepUpApproval step_up_approval */ 142:
                    message.typ = {
                        oneofKind: "stepUpApproval",
                        stepUpApproval: TaskAuditStepUpApproval.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).stepUpApproval)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditExternalTicketProvisionStepResolved external_ticket_provision_step_resolved */ 143:
                    message.typ = {
                        oneofKind: "externalTicketProvisionStepResolved",
                        externalTicketProvisionStepResolved: TaskAuditExternalTicketProvisionStepResolved.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).externalTicketProvisionStepResolved)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditStepSkipped step_skipped */ 144:
                    message.typ = {
                        oneofKind: "stepSkipped",
                        stepSkipped: TaskAuditStepSkipped.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).stepSkipped)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditReassignmentListError reassignment_list_error */ 145:
                    message.typ = {
                        oneofKind: "reassignmentListError",
                        reassignmentListError: TaskAuditReassignmentListError.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).reassignmentListError)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditSLAEscalation sla_escalation */ 146:
                    message.typ = {
                        oneofKind: "slaEscalation",
                        slaEscalation: TaskAuditSLAEscalation.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).slaEscalation)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditPolicyChanged policy_changed */ 147:
                    message.typ = {
                        oneofKind: "policyChanged",
                        policyChanged: TaskAuditPolicyChanged.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).policyChanged)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditFormInstanceChange form_instance_change */ 148:
                    message.typ = {
                        oneofKind: "formInstanceChange",
                        formInstanceChange: TaskAuditFormInstanceChange.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).formInstanceChange)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditGrantDurationUpdated grant_duration_updated */ 149:
                    message.typ = {
                        oneofKind: "grantDurationUpdated",
                        grantDurationUpdated: TaskAuditGrantDurationUpdated.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).grantDurationUpdated)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWaitStepUntilTime wait_step_until_time */ 150:
                    message.typ = {
                        oneofKind: "waitStepUntilTime",
                        waitStepUntilTime: TaskAuditWaitStepUntilTime.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).waitStepUntilTime)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditWebhookApprovalFatalError webhook_approval_fatal_error */ 151:
                    message.typ = {
                        oneofKind: "webhookApprovalFatalError",
                        webhookApprovalFatalError: TaskAuditWebhookApprovalFatalError.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).webhookApprovalFatalError)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditAccountLifecycleActionCreated account_lifecycle_action_created */ 152:
                    message.typ = {
                        oneofKind: "accountLifecycleActionCreated",
                        accountLifecycleActionCreated: TaskAuditAccountLifecycleActionCreated.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).accountLifecycleActionCreated)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditAccountLifecycleActionFailed account_lifecycle_action_failed */ 153:
                    message.typ = {
                        oneofKind: "accountLifecycleActionFailed",
                        accountLifecycleActionFailed: TaskAuditAccountLifecycleActionFailed.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).accountLifecycleActionFailed)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditPolicyProvisionCancelled provision_cancelled */ 154:
                    message.typ = {
                        oneofKind: "provisionCancelled",
                        provisionCancelled: TaskAuditPolicyProvisionCancelled.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).provisionCancelled)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditActionInstanceCreated action_instance_created */ 155:
                    message.typ = {
                        oneofKind: "actionInstanceCreated",
                        actionInstanceCreated: TaskAuditActionInstanceCreated.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).actionInstanceCreated)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditActionInstanceSucceeded action_instance_succeeded */ 156:
                    message.typ = {
                        oneofKind: "actionInstanceSucceeded",
                        actionInstanceSucceeded: TaskAuditActionInstanceSucceeded.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).actionInstanceSucceeded)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditActionInstanceFailed action_instance_failed */ 157:
                    message.typ = {
                        oneofKind: "actionInstanceFailed",
                        actionInstanceFailed: TaskAuditActionInstanceFailed.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).actionInstanceFailed)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditCreatedReplacementExtensionGrantTask created_replacement_extension_grant_task */ 158:
                    message.typ = {
                        oneofKind: "createdReplacementExtensionGrantTask",
                        createdReplacementExtensionGrantTask: TaskAuditCreatedReplacementExtensionGrantTask.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).createdReplacementExtensionGrantTask)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditNewTaskCreatedFrom task_created_from */ 159:
                    message.typ = {
                        oneofKind: "taskCreatedFrom",
                        taskCreatedFrom: TaskAuditNewTaskCreatedFrom.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).taskCreatedFrom)
                    };
                    break;
                case /* c1.api.task.v1.TaskAuditReassignmentFallbackToAdmin reassignment_fallback_to_admin */ 160:
                    message.typ = {
                        oneofKind: "reassignmentFallbackToAdmin",
                        reassignmentFallbackToAdmin: TaskAuditReassignmentFallbackToAdmin.internalBinaryRead(reader, reader.uint32(), options, (message.typ as any).reassignmentFallbackToAdmin)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* c1.api.task.v1.TaskState current_state = 3; */
        if (message.currentState !== 0)
            writer.tag(3, WireType.Varint).int32(message.currentState);
        /* int32 workflow_step = 4; */
        if (message.workflowStep !== 0)
            writer.tag(4, WireType.Varint).int32(message.workflowStep);
        /* google.protobuf.Timestamp created = 5; */
        if (message.created)
            Timestamp.internalBinaryWrite(message.created, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditMetaData metadata = 6; */
        if (message.metadata)
            TaskAuditMetaData.internalBinaryWrite(message.metadata, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditEventType event_type = 7; */
        if (message.eventType !== 0)
            writer.tag(7, WireType.Varint).int32(message.eventType);
        /* c1.api.task.v1.Source source = 8; */
        if (message.source !== 0)
            writer.tag(8, WireType.Varint).int32(message.source);
        /* string ticket_id = 9; */
        if (message.ticketId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.ticketId);
        /* c1.api.task.v1.TaskAuditComment comment = 100; */
        if (message.typ.oneofKind === "comment")
            TaskAuditComment.internalBinaryWrite(message.typ.comment, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditStateChange state_change = 101; */
        if (message.typ.oneofKind === "stateChange")
            TaskAuditStateChange.internalBinaryWrite(message.typ.stateChange, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditApprovalInstanceChange approval_instance_change = 102; */
        if (message.typ.oneofKind === "approvalInstanceChange")
            TaskAuditApprovalInstanceChange.internalBinaryWrite(message.typ.approvalInstanceChange, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditStartedConnectorActions connector_actions_start = 103; */
        if (message.typ.oneofKind === "connectorActionsStart")
            TaskAuditStartedConnectorActions.internalBinaryWrite(message.typ.connectorActionsStart, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditFinishedConnectorActions connector_actions_end = 104; */
        if (message.typ.oneofKind === "connectorActionsEnd")
            TaskAuditFinishedConnectorActions.internalBinaryWrite(message.typ.connectorActionsEnd, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditConnectorActionResult action_result = 105; */
        if (message.typ.oneofKind === "actionResult")
            TaskAuditConnectorActionResult.internalBinaryWrite(message.typ.actionResult, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditNewTask task_created = 106; */
        if (message.typ.oneofKind === "taskCreated")
            TaskAuditNewTask.internalBinaryWrite(message.typ.taskCreated, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditCertifyOutcome certify_outcome = 107; */
        if (message.typ.oneofKind === "certifyOutcome")
            TaskAuditCertifyOutcome.internalBinaryWrite(message.typ.certifyOutcome, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditActionSubmitted action_submitted = 108; */
        if (message.typ.oneofKind === "actionSubmitted")
            TaskAuditActionSubmitted.internalBinaryWrite(message.typ.actionSubmitted, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditGrantOutcome grant_outcome = 109; */
        if (message.typ.oneofKind === "grantOutcome")
            TaskAuditGrantOutcome.internalBinaryWrite(message.typ.grantOutcome, writer.tag(109, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditRevokeOutcome revoke_outcome = 110; */
        if (message.typ.oneofKind === "revokeOutcome")
            TaskAuditRevokeOutcome.internalBinaryWrite(message.typ.revokeOutcome, writer.tag(110, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditPolicyApprovalReassigned approval_reassigned = 111; */
        if (message.typ.oneofKind === "approvalReassigned")
            TaskAuditPolicyApprovalReassigned.internalBinaryWrite(message.typ.approvalReassigned, writer.tag(111, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditRestart task_restarted = 112; */
        if (message.typ.oneofKind === "taskRestarted")
            TaskAuditRestart.internalBinaryWrite(message.typ.taskRestarted, writer.tag(112, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditAccessRequestOutcome access_request_outcome = 113; */
        if (message.typ.oneofKind === "accessRequestOutcome")
            TaskAuditAccessRequestOutcome.internalBinaryWrite(message.typ.accessRequestOutcome, writer.tag(113, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditPolicyProvisionReassigned provision_reassigned = 114; */
        if (message.typ.oneofKind === "provisionReassigned")
            TaskAuditPolicyProvisionReassigned.internalBinaryWrite(message.typ.provisionReassigned, writer.tag(114, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditPolicyProvisionError provision_error = 115; */
        if (message.typ.oneofKind === "provisionError")
            TaskAuditPolicyProvisionError.internalBinaryWrite(message.typ.provisionError, writer.tag(115, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditApprovalHappenedAutomatically approved_automatically = 116; */
        if (message.typ.oneofKind === "approvedAutomatically")
            TaskAuditApprovalHappenedAutomatically.internalBinaryWrite(message.typ.approvedAutomatically, writer.tag(116, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditReassignedToDelegate reassigned_to_delegate = 117; */
        if (message.typ.oneofKind === "reassignedToDelegate")
            TaskAuditReassignedToDelegate.internalBinaryWrite(message.typ.reassignedToDelegate, writer.tag(117, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditHardReset hard_reset = 118; */
        if (message.typ.oneofKind === "hardReset")
            TaskAuditHardReset.internalBinaryWrite(message.typ.hardReset, writer.tag(118, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditEscalateToEmergencyAccess task_escalated = 119; */
        if (message.typ.oneofKind === "taskEscalated")
            TaskAuditEscalateToEmergencyAccess.internalBinaryWrite(message.typ.taskEscalated, writer.tag(119, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditConditionalPolicyExecutionResult conditional_policy_execution_result = 120; */
        if (message.typ.oneofKind === "conditionalPolicyExecutionResult")
            TaskAuditConditionalPolicyExecutionResult.internalBinaryWrite(message.typ.conditionalPolicyExecutionResult, writer.tag(120, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditExpressionPolicyStepError expression_policy_step_error = 121; */
        if (message.typ.oneofKind === "expressionPolicyStepError")
            TaskAuditExpressionPolicyStepError.internalBinaryWrite(message.typ.expressionPolicyStepError, writer.tag(121, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditApprovalAutoAcceptedByPolicy approval_auto_accepted_by_policy = 122; */
        if (message.typ.oneofKind === "approvalAutoAcceptedByPolicy")
            TaskAuditApprovalAutoAcceptedByPolicy.internalBinaryWrite(message.typ.approvalAutoAcceptedByPolicy, writer.tag(122, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditApprovalAutoRejectedByPolicy approval_auto_rejected_by_policy = 123; */
        if (message.typ.oneofKind === "approvalAutoRejectedByPolicy")
            TaskAuditApprovalAutoRejectedByPolicy.internalBinaryWrite(message.typ.approvalAutoRejectedByPolicy, writer.tag(123, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditBulkActionError bulk_action_error = 124; */
        if (message.typ.oneofKind === "bulkActionError")
            TaskAuditBulkActionError.internalBinaryWrite(message.typ.bulkActionError, writer.tag(124, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWebhookTriggered webhook_triggered = 125; */
        if (message.typ.oneofKind === "webhookTriggered")
            TaskAuditWebhookTriggered.internalBinaryWrite(message.typ.webhookTriggered, writer.tag(125, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWebhookAttempt webhook_attempt = 126; */
        if (message.typ.oneofKind === "webhookAttempt")
            TaskAuditWebhookAttempt.internalBinaryWrite(message.typ.webhookAttempt, writer.tag(126, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWebhookSuccess webhook_success = 127; */
        if (message.typ.oneofKind === "webhookSuccess")
            TaskAuditWebhookSuccess.internalBinaryWrite(message.typ.webhookSuccess, writer.tag(127, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditPolicyEvaluationStep policy_evaluation_step = 128; */
        if (message.typ.oneofKind === "policyEvaluationStep")
            TaskAuditPolicyEvaluationStep.internalBinaryWrite(message.typ.policyEvaluationStep, writer.tag(128, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWaitStepSuccess wait_step_success = 129; */
        if (message.typ.oneofKind === "waitStepSuccess")
            TaskAuditWaitStepSuccess.internalBinaryWrite(message.typ.waitStepSuccess, writer.tag(129, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWaitStepWaiting wait_step_waiting = 130; */
        if (message.typ.oneofKind === "waitStepWaiting")
            TaskAuditWaitStepWaiting.internalBinaryWrite(message.typ.waitStepWaiting, writer.tag(130, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWaitStepTimedOut wait_step_timed_out = 131; */
        if (message.typ.oneofKind === "waitStepTimedOut")
            TaskAuditWaitStepTimedOut.internalBinaryWrite(message.typ.waitStepTimedOut, writer.tag(131, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWebhookApprovalTriggered webhook_approval_triggered = 132; */
        if (message.typ.oneofKind === "webhookApprovalTriggered")
            TaskAuditWebhookApprovalTriggered.internalBinaryWrite(message.typ.webhookApprovalTriggered, writer.tag(132, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWebhookApprovalAttempt webhook_approval_attempt = 133; */
        if (message.typ.oneofKind === "webhookApprovalAttempt")
            TaskAuditWebhookApprovalAttempt.internalBinaryWrite(message.typ.webhookApprovalAttempt, writer.tag(133, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWebhookApprovalSuccess webhook_approval_success = 134; */
        if (message.typ.oneofKind === "webhookApprovalSuccess")
            TaskAuditWebhookApprovalSuccess.internalBinaryWrite(message.typ.webhookApprovalSuccess, writer.tag(134, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWebhookApprovalBadResponse webhook_approval_bad_response = 135; */
        if (message.typ.oneofKind === "webhookApprovalBadResponse")
            TaskAuditWebhookApprovalBadResponse.internalBinaryWrite(message.typ.webhookApprovalBadResponse, writer.tag(135, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditExternalTicketTriggered external_ticket_triggered = 136; */
        if (message.typ.oneofKind === "externalTicketTriggered")
            TaskAuditExternalTicketTriggered.internalBinaryWrite(message.typ.externalTicketTriggered, writer.tag(136, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditExternalTicketCreated external_ticket_created = 137; */
        if (message.typ.oneofKind === "externalTicketCreated")
            TaskAuditExternalTicketCreated.internalBinaryWrite(message.typ.externalTicketCreated, writer.tag(137, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditExternalTicketError external_ticket_error = 138; */
        if (message.typ.oneofKind === "externalTicketError")
            TaskAuditExternalTicketError.internalBinaryWrite(message.typ.externalTicketError, writer.tag(138, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWaitForAnalysisStepSuccess wait_step_analysis_success = 139; */
        if (message.typ.oneofKind === "waitStepAnalysisSuccess")
            TaskAuditWaitForAnalysisStepSuccess.internalBinaryWrite(message.typ.waitStepAnalysisSuccess, writer.tag(139, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWaitForAnalysisStepWaiting wait_step_analysis_waiting = 140; */
        if (message.typ.oneofKind === "waitStepAnalysisWaiting")
            TaskAuditWaitForAnalysisStepWaiting.internalBinaryWrite(message.typ.waitStepAnalysisWaiting, writer.tag(140, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWaitForAnalysisStepTimedOut wait_step_analysis_timed_out = 141; */
        if (message.typ.oneofKind === "waitStepAnalysisTimedOut")
            TaskAuditWaitForAnalysisStepTimedOut.internalBinaryWrite(message.typ.waitStepAnalysisTimedOut, writer.tag(141, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditStepUpApproval step_up_approval = 142; */
        if (message.typ.oneofKind === "stepUpApproval")
            TaskAuditStepUpApproval.internalBinaryWrite(message.typ.stepUpApproval, writer.tag(142, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditExternalTicketProvisionStepResolved external_ticket_provision_step_resolved = 143; */
        if (message.typ.oneofKind === "externalTicketProvisionStepResolved")
            TaskAuditExternalTicketProvisionStepResolved.internalBinaryWrite(message.typ.externalTicketProvisionStepResolved, writer.tag(143, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditStepSkipped step_skipped = 144; */
        if (message.typ.oneofKind === "stepSkipped")
            TaskAuditStepSkipped.internalBinaryWrite(message.typ.stepSkipped, writer.tag(144, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditReassignmentListError reassignment_list_error = 145; */
        if (message.typ.oneofKind === "reassignmentListError")
            TaskAuditReassignmentListError.internalBinaryWrite(message.typ.reassignmentListError, writer.tag(145, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditSLAEscalation sla_escalation = 146; */
        if (message.typ.oneofKind === "slaEscalation")
            TaskAuditSLAEscalation.internalBinaryWrite(message.typ.slaEscalation, writer.tag(146, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditPolicyChanged policy_changed = 147; */
        if (message.typ.oneofKind === "policyChanged")
            TaskAuditPolicyChanged.internalBinaryWrite(message.typ.policyChanged, writer.tag(147, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditFormInstanceChange form_instance_change = 148; */
        if (message.typ.oneofKind === "formInstanceChange")
            TaskAuditFormInstanceChange.internalBinaryWrite(message.typ.formInstanceChange, writer.tag(148, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditGrantDurationUpdated grant_duration_updated = 149; */
        if (message.typ.oneofKind === "grantDurationUpdated")
            TaskAuditGrantDurationUpdated.internalBinaryWrite(message.typ.grantDurationUpdated, writer.tag(149, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWaitStepUntilTime wait_step_until_time = 150; */
        if (message.typ.oneofKind === "waitStepUntilTime")
            TaskAuditWaitStepUntilTime.internalBinaryWrite(message.typ.waitStepUntilTime, writer.tag(150, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditWebhookApprovalFatalError webhook_approval_fatal_error = 151; */
        if (message.typ.oneofKind === "webhookApprovalFatalError")
            TaskAuditWebhookApprovalFatalError.internalBinaryWrite(message.typ.webhookApprovalFatalError, writer.tag(151, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditAccountLifecycleActionCreated account_lifecycle_action_created = 152; */
        if (message.typ.oneofKind === "accountLifecycleActionCreated")
            TaskAuditAccountLifecycleActionCreated.internalBinaryWrite(message.typ.accountLifecycleActionCreated, writer.tag(152, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditAccountLifecycleActionFailed account_lifecycle_action_failed = 153; */
        if (message.typ.oneofKind === "accountLifecycleActionFailed")
            TaskAuditAccountLifecycleActionFailed.internalBinaryWrite(message.typ.accountLifecycleActionFailed, writer.tag(153, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditPolicyProvisionCancelled provision_cancelled = 154; */
        if (message.typ.oneofKind === "provisionCancelled")
            TaskAuditPolicyProvisionCancelled.internalBinaryWrite(message.typ.provisionCancelled, writer.tag(154, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditActionInstanceCreated action_instance_created = 155; */
        if (message.typ.oneofKind === "actionInstanceCreated")
            TaskAuditActionInstanceCreated.internalBinaryWrite(message.typ.actionInstanceCreated, writer.tag(155, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditActionInstanceSucceeded action_instance_succeeded = 156; */
        if (message.typ.oneofKind === "actionInstanceSucceeded")
            TaskAuditActionInstanceSucceeded.internalBinaryWrite(message.typ.actionInstanceSucceeded, writer.tag(156, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditActionInstanceFailed action_instance_failed = 157; */
        if (message.typ.oneofKind === "actionInstanceFailed")
            TaskAuditActionInstanceFailed.internalBinaryWrite(message.typ.actionInstanceFailed, writer.tag(157, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditCreatedReplacementExtensionGrantTask created_replacement_extension_grant_task = 158; */
        if (message.typ.oneofKind === "createdReplacementExtensionGrantTask")
            TaskAuditCreatedReplacementExtensionGrantTask.internalBinaryWrite(message.typ.createdReplacementExtensionGrantTask, writer.tag(158, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditNewTaskCreatedFrom task_created_from = 159; */
        if (message.typ.oneofKind === "taskCreatedFrom")
            TaskAuditNewTaskCreatedFrom.internalBinaryWrite(message.typ.taskCreatedFrom, writer.tag(159, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskAuditReassignmentFallbackToAdmin reassignment_fallback_to_admin = 160; */
        if (message.typ.oneofKind === "reassignmentFallbackToAdmin")
            TaskAuditReassignmentFallbackToAdmin.internalBinaryWrite(message.typ.reassignmentFallbackToAdmin, writer.tag(160, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditView
 */
export const TaskAuditView = new TaskAuditView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditViewRef$Type extends MessageType<TaskAuditViewRef> {
    constructor() {
        super("c1.api.task.v1.TaskAuditViewRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<TaskAuditViewRef>): TaskAuditViewRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditViewRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditViewRef): TaskAuditViewRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditViewRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditViewRef
 */
export const TaskAuditViewRef = new TaskAuditViewRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditStepUpApproval$Type extends MessageType<TaskAuditStepUpApproval> {
    constructor() {
        super("c1.api.task.v1.TaskAuditStepUpApproval", [
            { no: 1, name: "step_up_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditStepUpApproval>): TaskAuditStepUpApproval {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepUpTransactionId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditStepUpApproval>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditStepUpApproval): TaskAuditStepUpApproval {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_up_transaction_id */ 1:
                    message.stepUpTransactionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditStepUpApproval, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_up_transaction_id = 1; */
        if (message.stepUpTransactionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepUpTransactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditStepUpApproval
 */
export const TaskAuditStepUpApproval = new TaskAuditStepUpApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditReassignmentListError$Type extends MessageType<TaskAuditReassignmentListError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditReassignmentListError", [
            { no: 1, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditReassignmentListError>): TaskAuditReassignmentListError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditReassignmentListError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditReassignmentListError): TaskAuditReassignmentListError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string error_message */ 1:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditReassignmentListError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string error_message = 1; */
        if (message.errorMessage !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditReassignmentListError
 */
export const TaskAuditReassignmentListError = new TaskAuditReassignmentListError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditStepSkipped$Type extends MessageType<TaskAuditStepSkipped> {
    constructor() {
        super("c1.api.task.v1.TaskAuditStepSkipped", [
            { no: 1, name: "skipped_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditStepSkipped>): TaskAuditStepSkipped {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.skippedBy = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditStepSkipped>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditStepSkipped): TaskAuditStepSkipped {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string skipped_by */ 1:
                    message.skippedBy = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditStepSkipped, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string skipped_by = 1; */
        if (message.skippedBy !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.skippedBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditStepSkipped
 */
export const TaskAuditStepSkipped = new TaskAuditStepSkipped$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditActionSubmitted$Type extends MessageType<TaskAuditActionSubmitted> {
    constructor() {
        super("c1.api.task.v1.TaskAuditActionSubmitted", [
            { no: 1, name: "action", kind: "message", T: () => TaskAction }
        ]);
    }
    create(value?: PartialMessage<TaskAuditActionSubmitted>): TaskAuditActionSubmitted {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditActionSubmitted>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditActionSubmitted): TaskAuditActionSubmitted {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskAction action */ 1:
                    message.action = TaskAction.internalBinaryRead(reader, reader.uint32(), options, message.action);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditActionSubmitted, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskAction action = 1; */
        if (message.action)
            TaskAction.internalBinaryWrite(message.action, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditActionSubmitted
 */
export const TaskAuditActionSubmitted = new TaskAuditActionSubmitted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditCertifyOutcome$Type extends MessageType<TaskAuditCertifyOutcome> {
    constructor() {
        super("c1.api.task.v1.TaskAuditCertifyOutcome", [
            { no: 1, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.CertifyOutcome", CertifyOutcome, "CERTIFY_OUTCOME_"] }
        ]);
    }
    create(value?: PartialMessage<TaskAuditCertifyOutcome>): TaskAuditCertifyOutcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.outcome = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskAuditCertifyOutcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditCertifyOutcome): TaskAuditCertifyOutcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.CertifyOutcome outcome */ 1:
                    message.outcome = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditCertifyOutcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.CertifyOutcome outcome = 1; */
        if (message.outcome !== 0)
            writer.tag(1, WireType.Varint).int32(message.outcome);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditCertifyOutcome
 */
export const TaskAuditCertifyOutcome = new TaskAuditCertifyOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditGrantOutcome$Type extends MessageType<TaskAuditGrantOutcome> {
    constructor() {
        super("c1.api.task.v1.TaskAuditGrantOutcome", [
            { no: 1, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.GrantOutcome", GrantOutcome, "GRANT_OUTCOME_"] }
        ]);
    }
    create(value?: PartialMessage<TaskAuditGrantOutcome>): TaskAuditGrantOutcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.outcome = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskAuditGrantOutcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditGrantOutcome): TaskAuditGrantOutcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.GrantOutcome outcome */ 1:
                    message.outcome = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditGrantOutcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.GrantOutcome outcome = 1; */
        if (message.outcome !== 0)
            writer.tag(1, WireType.Varint).int32(message.outcome);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditGrantOutcome
 */
export const TaskAuditGrantOutcome = new TaskAuditGrantOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditRevokeOutcome$Type extends MessageType<TaskAuditRevokeOutcome> {
    constructor() {
        super("c1.api.task.v1.TaskAuditRevokeOutcome", [
            { no: 1, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.RevokeOutcome", RevokeOutcome, "REVOKE_OUTCOME_"] }
        ]);
    }
    create(value?: PartialMessage<TaskAuditRevokeOutcome>): TaskAuditRevokeOutcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.outcome = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskAuditRevokeOutcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditRevokeOutcome): TaskAuditRevokeOutcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.RevokeOutcome outcome */ 1:
                    message.outcome = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditRevokeOutcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.RevokeOutcome outcome = 1; */
        if (message.outcome !== 0)
            writer.tag(1, WireType.Varint).int32(message.outcome);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditRevokeOutcome
 */
export const TaskAuditRevokeOutcome = new TaskAuditRevokeOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditAccessRequestOutcome$Type extends MessageType<TaskAuditAccessRequestOutcome> {
    constructor() {
        super("c1.api.task.v1.TaskAuditAccessRequestOutcome", [
            { no: 1, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.AccessRequestOutcome", AccessRequestOutcome, "ACCESS_REQUEST_OUTCOME_"] }
        ]);
    }
    create(value?: PartialMessage<TaskAuditAccessRequestOutcome>): TaskAuditAccessRequestOutcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.outcome = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskAuditAccessRequestOutcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditAccessRequestOutcome): TaskAuditAccessRequestOutcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.AccessRequestOutcome outcome */ 1:
                    message.outcome = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditAccessRequestOutcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.AccessRequestOutcome outcome = 1; */
        if (message.outcome !== 0)
            writer.tag(1, WireType.Varint).int32(message.outcome);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditAccessRequestOutcome
 */
export const TaskAuditAccessRequestOutcome = new TaskAuditAccessRequestOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditStartedConnectorActions$Type extends MessageType<TaskAuditStartedConnectorActions> {
    constructor() {
        super("c1.api.task.v1.TaskAuditStartedConnectorActions", [
            { no: 1, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<TaskAuditStartedConnectorActions>): TaskAuditStartedConnectorActions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.policyStepId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditStartedConnectorActions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditStartedConnectorActions): TaskAuditStartedConnectorActions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string policy_step_id */ 1:
                    message.policyStepId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditStartedConnectorActions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string policy_step_id = 1; */
        if (message.policyStepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.policyStepId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditStartedConnectorActions
 */
export const TaskAuditStartedConnectorActions = new TaskAuditStartedConnectorActions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditFinishedConnectorActions$Type extends MessageType<TaskAuditFinishedConnectorActions> {
    constructor() {
        super("c1.api.task.v1.TaskAuditFinishedConnectorActions", [
            { no: 1, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<TaskAuditFinishedConnectorActions>): TaskAuditFinishedConnectorActions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.policyStepId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditFinishedConnectorActions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditFinishedConnectorActions): TaskAuditFinishedConnectorActions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string policy_step_id */ 1:
                    message.policyStepId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditFinishedConnectorActions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string policy_step_id = 1; */
        if (message.policyStepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.policyStepId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditFinishedConnectorActions
 */
export const TaskAuditFinishedConnectorActions = new TaskAuditFinishedConnectorActions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditNewTask$Type extends MessageType<TaskAuditNewTask> {
    constructor() {
        super("c1.api.task.v1.TaskAuditNewTask", []);
    }
    create(value?: PartialMessage<TaskAuditNewTask>): TaskAuditNewTask {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditNewTask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditNewTask): TaskAuditNewTask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditNewTask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditNewTask
 */
export const TaskAuditNewTask = new TaskAuditNewTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditConnectorActionResult$Type extends MessageType<TaskAuditConnectorActionResult> {
    constructor() {
        super("c1.api.task.v1.TaskAuditConnectorActionResult", [
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 5, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 6, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 7, name: "connector_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 1, name: "success", kind: "message", oneof: "result", T: () => TaskAuditSuccessResult },
            { no: 2, name: "error", kind: "message", oneof: "result", T: () => TaskAuditErrorResult },
            { no: 3, name: "cancelled", kind: "message", oneof: "result", T: () => TaskAuditCancelledResult }
        ]);
    }
    create(value?: PartialMessage<TaskAuditConnectorActionResult>): TaskAuditConnectorActionResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.connectorId = "";
        message.connectorActionId = "";
        message.result = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<TaskAuditConnectorActionResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditConnectorActionResult): TaskAuditConnectorActionResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 5:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string connector_id */ 6:
                    message.connectorId = reader.string();
                    break;
                case /* string connector_action_id */ 7:
                    message.connectorActionId = reader.string();
                    break;
                case /* c1.api.app.v1.TaskAuditSuccessResult success */ 1:
                    message.result = {
                        oneofKind: "success",
                        success: TaskAuditSuccessResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).success)
                    };
                    break;
                case /* c1.api.app.v1.TaskAuditErrorResult error */ 2:
                    message.result = {
                        oneofKind: "error",
                        error: TaskAuditErrorResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).error)
                    };
                    break;
                case /* c1.api.app.v1.TaskAuditCancelledResult cancelled */ 3:
                    message.result = {
                        oneofKind: "cancelled",
                        cancelled: TaskAuditCancelledResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).cancelled)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditConnectorActionResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.TaskAuditSuccessResult success = 1; */
        if (message.result.oneofKind === "success")
            TaskAuditSuccessResult.internalBinaryWrite(message.result.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.TaskAuditErrorResult error = 2; */
        if (message.result.oneofKind === "error")
            TaskAuditErrorResult.internalBinaryWrite(message.result.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.TaskAuditCancelledResult cancelled = 3; */
        if (message.result.oneofKind === "cancelled")
            TaskAuditCancelledResult.internalBinaryWrite(message.result.cancelled, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 5; */
        if (message.appEntitlementId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string connector_id = 6; */
        if (message.connectorId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.connectorId);
        /* string connector_action_id = 7; */
        if (message.connectorActionId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.connectorActionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditConnectorActionResult
 */
export const TaskAuditConnectorActionResult = new TaskAuditConnectorActionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditComment$Type extends MessageType<TaskAuditComment> {
    constructor() {
        super("c1.api.task.v1.TaskAuditComment", [
            { no: 1, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "updated_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<TaskAuditComment>): TaskAuditComment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.comment = "";
        message.updatedBy = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditComment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditComment): TaskAuditComment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string comment */ 1:
                    message.comment = reader.string();
                    break;
                case /* string updated_by */ 2:
                    message.updatedBy = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditComment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string comment = 1; */
        if (message.comment !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.comment);
        /* string updated_by = 2; */
        if (message.updatedBy !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.updatedBy);
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditComment
 */
export const TaskAuditComment = new TaskAuditComment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditStateChange$Type extends MessageType<TaskAuditStateChange> {
    constructor() {
        super("c1.api.task.v1.TaskAuditStateChange", [
            { no: 4, name: "previous_state", kind: "enum", T: () => ["c1.api.task.v1.TaskState", TaskState, "TASK_STATE_"] }
        ]);
    }
    create(value?: PartialMessage<TaskAuditStateChange>): TaskAuditStateChange {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.previousState = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskAuditStateChange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditStateChange): TaskAuditStateChange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskState previous_state */ 4:
                    message.previousState = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditStateChange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskState previous_state = 4; */
        if (message.previousState !== 0)
            writer.tag(4, WireType.Varint).int32(message.previousState);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditStateChange
 */
export const TaskAuditStateChange = new TaskAuditStateChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditApprovalInstanceChange$Type extends MessageType<TaskAuditApprovalInstanceChange> {
    constructor() {
        super("c1.api.task.v1.TaskAuditApprovalInstanceChange", [
            { no: 4, name: "instance", kind: "message", T: () => ApprovalInstance }
        ]);
    }
    create(value?: PartialMessage<TaskAuditApprovalInstanceChange>): TaskAuditApprovalInstanceChange {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditApprovalInstanceChange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditApprovalInstanceChange): TaskAuditApprovalInstanceChange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.policy.v1.ApprovalInstance instance */ 4:
                    message.instance = ApprovalInstance.internalBinaryRead(reader, reader.uint32(), options, message.instance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditApprovalInstanceChange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.policy.v1.ApprovalInstance instance = 4; */
        if (message.instance)
            ApprovalInstance.internalBinaryWrite(message.instance, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditApprovalInstanceChange
 */
export const TaskAuditApprovalInstanceChange = new TaskAuditApprovalInstanceChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditActionInstanceCreated$Type extends MessageType<TaskAuditActionInstanceCreated> {
    constructor() {
        super("c1.api.task.v1.TaskAuditActionInstanceCreated", [
            { no: 1, name: "instance", kind: "message", T: () => ActionInstance }
        ]);
    }
    create(value?: PartialMessage<TaskAuditActionInstanceCreated>): TaskAuditActionInstanceCreated {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditActionInstanceCreated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditActionInstanceCreated): TaskAuditActionInstanceCreated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.policy.v1.ActionInstance instance */ 1:
                    message.instance = ActionInstance.internalBinaryRead(reader, reader.uint32(), options, message.instance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditActionInstanceCreated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.policy.v1.ActionInstance instance = 1; */
        if (message.instance)
            ActionInstance.internalBinaryWrite(message.instance, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditActionInstanceCreated
 */
export const TaskAuditActionInstanceCreated = new TaskAuditActionInstanceCreated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditActionInstanceSucceeded$Type extends MessageType<TaskAuditActionInstanceSucceeded> {
    constructor() {
        super("c1.api.task.v1.TaskAuditActionInstanceSucceeded", [
            { no: 1, name: "instance", kind: "message", T: () => ActionInstance }
        ]);
    }
    create(value?: PartialMessage<TaskAuditActionInstanceSucceeded>): TaskAuditActionInstanceSucceeded {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditActionInstanceSucceeded>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditActionInstanceSucceeded): TaskAuditActionInstanceSucceeded {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.policy.v1.ActionInstance instance */ 1:
                    message.instance = ActionInstance.internalBinaryRead(reader, reader.uint32(), options, message.instance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditActionInstanceSucceeded, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.policy.v1.ActionInstance instance = 1; */
        if (message.instance)
            ActionInstance.internalBinaryWrite(message.instance, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditActionInstanceSucceeded
 */
export const TaskAuditActionInstanceSucceeded = new TaskAuditActionInstanceSucceeded$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditActionInstanceFailed$Type extends MessageType<TaskAuditActionInstanceFailed> {
    constructor() {
        super("c1.api.task.v1.TaskAuditActionInstanceFailed", [
            { no: 1, name: "instance", kind: "message", T: () => ActionInstance }
        ]);
    }
    create(value?: PartialMessage<TaskAuditActionInstanceFailed>): TaskAuditActionInstanceFailed {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditActionInstanceFailed>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditActionInstanceFailed): TaskAuditActionInstanceFailed {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.policy.v1.ActionInstance instance */ 1:
                    message.instance = ActionInstance.internalBinaryRead(reader, reader.uint32(), options, message.instance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditActionInstanceFailed, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.policy.v1.ActionInstance instance = 1; */
        if (message.instance)
            ActionInstance.internalBinaryWrite(message.instance, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditActionInstanceFailed
 */
export const TaskAuditActionInstanceFailed = new TaskAuditActionInstanceFailed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditApprovalAutoAcceptedByPolicy$Type extends MessageType<TaskAuditApprovalAutoAcceptedByPolicy> {
    constructor() {
        super("c1.api.task.v1.TaskAuditApprovalAutoAcceptedByPolicy", []);
    }
    create(value?: PartialMessage<TaskAuditApprovalAutoAcceptedByPolicy>): TaskAuditApprovalAutoAcceptedByPolicy {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditApprovalAutoAcceptedByPolicy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditApprovalAutoAcceptedByPolicy): TaskAuditApprovalAutoAcceptedByPolicy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditApprovalAutoAcceptedByPolicy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditApprovalAutoAcceptedByPolicy
 */
export const TaskAuditApprovalAutoAcceptedByPolicy = new TaskAuditApprovalAutoAcceptedByPolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditApprovalAutoRejectedByPolicy$Type extends MessageType<TaskAuditApprovalAutoRejectedByPolicy> {
    constructor() {
        super("c1.api.task.v1.TaskAuditApprovalAutoRejectedByPolicy", []);
    }
    create(value?: PartialMessage<TaskAuditApprovalAutoRejectedByPolicy>): TaskAuditApprovalAutoRejectedByPolicy {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditApprovalAutoRejectedByPolicy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditApprovalAutoRejectedByPolicy): TaskAuditApprovalAutoRejectedByPolicy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditApprovalAutoRejectedByPolicy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditApprovalAutoRejectedByPolicy
 */
export const TaskAuditApprovalAutoRejectedByPolicy = new TaskAuditApprovalAutoRejectedByPolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditApprovalHappenedAutomatically$Type extends MessageType<TaskAuditApprovalHappenedAutomatically> {
    constructor() {
        super("c1.api.task.v1.TaskAuditApprovalHappenedAutomatically", []);
    }
    create(value?: PartialMessage<TaskAuditApprovalHappenedAutomatically>): TaskAuditApprovalHappenedAutomatically {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditApprovalHappenedAutomatically>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditApprovalHappenedAutomatically): TaskAuditApprovalHappenedAutomatically {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditApprovalHappenedAutomatically, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditApprovalHappenedAutomatically
 */
export const TaskAuditApprovalHappenedAutomatically = new TaskAuditApprovalHappenedAutomatically$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditMetaData$Type extends MessageType<TaskAuditMetaData> {
    constructor() {
        super("c1.api.task.v1.TaskAuditMetaData", [
            { no: 2, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value?: PartialMessage<TaskAuditMetaData>): TaskAuditMetaData {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditMetaData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditMetaData): TaskAuditMetaData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user */ 2:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditMetaData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 2; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditMetaData
 */
export const TaskAuditMetaData = new TaskAuditMetaData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyApprovalReassigned$Type extends MessageType<TaskAuditPolicyApprovalReassigned> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyApprovalReassigned", [
            { no: 1, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "new_users", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<TaskAuditPolicyApprovalReassigned>): TaskAuditPolicyApprovalReassigned {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.oldPolicyStepId = "";
        message.newPolicyStepId = "";
        message.newUsers = [];
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial<TaskAuditPolicyApprovalReassigned>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditPolicyApprovalReassigned): TaskAuditPolicyApprovalReassigned {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string old_policy_step_id */ 1:
                    message.oldPolicyStepId = reader.string();
                    break;
                case /* string new_policy_step_id */ 2:
                    message.newPolicyStepId = reader.string();
                    break;
                case /* repeated string new_users */ 3:
                    message.newUsers.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.User users */ 4:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditPolicyApprovalReassigned, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string old_policy_step_id = 1; */
        if (message.oldPolicyStepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.oldPolicyStepId);
        /* string new_policy_step_id = 2; */
        if (message.newPolicyStepId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.newPolicyStepId);
        /* repeated string new_users = 3; */
        for (let i = 0; i < message.newUsers.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.newUsers[i]);
        /* repeated c1.api.user.v1.User users = 4; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyApprovalReassigned
 */
export const TaskAuditPolicyApprovalReassigned = new TaskAuditPolicyApprovalReassigned$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyProvisionReassigned$Type extends MessageType<TaskAuditPolicyProvisionReassigned> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyProvisionReassigned", [
            { no: 1, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "new_users", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<TaskAuditPolicyProvisionReassigned>): TaskAuditPolicyProvisionReassigned {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.oldPolicyStepId = "";
        message.newPolicyStepId = "";
        message.newUsers = [];
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial<TaskAuditPolicyProvisionReassigned>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditPolicyProvisionReassigned): TaskAuditPolicyProvisionReassigned {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string old_policy_step_id */ 1:
                    message.oldPolicyStepId = reader.string();
                    break;
                case /* string new_policy_step_id */ 2:
                    message.newPolicyStepId = reader.string();
                    break;
                case /* repeated string new_users */ 3:
                    message.newUsers.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.User users */ 4:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditPolicyProvisionReassigned, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string old_policy_step_id = 1; */
        if (message.oldPolicyStepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.oldPolicyStepId);
        /* string new_policy_step_id = 2; */
        if (message.newPolicyStepId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.newPolicyStepId);
        /* repeated string new_users = 3; */
        for (let i = 0; i < message.newUsers.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.newUsers[i]);
        /* repeated c1.api.user.v1.User users = 4; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyProvisionReassigned
 */
export const TaskAuditPolicyProvisionReassigned = new TaskAuditPolicyProvisionReassigned$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyProvisionError$Type extends MessageType<TaskAuditPolicyProvisionError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyProvisionError", [
            { no: 1, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditPolicyProvisionError>): TaskAuditPolicyProvisionError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditPolicyProvisionError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditPolicyProvisionError): TaskAuditPolicyProvisionError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string error */ 1:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditPolicyProvisionError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string error = 1; */
        if (message.error !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyProvisionError
 */
export const TaskAuditPolicyProvisionError = new TaskAuditPolicyProvisionError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditReassignedToDelegate$Type extends MessageType<TaskAuditReassignedToDelegate> {
    constructor() {
        super("c1.api.task.v1.TaskAuditReassignedToDelegate", [
            { no: 1, name: "original_assignee_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "delegated_assignee_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "original_assignee_user", kind: "message", T: () => User },
            { no: 4, name: "delegated_assignee_user", kind: "message", T: () => User }
        ]);
    }
    create(value?: PartialMessage<TaskAuditReassignedToDelegate>): TaskAuditReassignedToDelegate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.originalAssigneeUserId = "";
        message.delegatedAssigneeUserId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditReassignedToDelegate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditReassignedToDelegate): TaskAuditReassignedToDelegate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string original_assignee_user_id */ 1:
                    message.originalAssigneeUserId = reader.string();
                    break;
                case /* string delegated_assignee_user_id */ 2:
                    message.delegatedAssigneeUserId = reader.string();
                    break;
                case /* c1.api.user.v1.User original_assignee_user */ 3:
                    message.originalAssigneeUser = User.internalBinaryRead(reader, reader.uint32(), options, message.originalAssigneeUser);
                    break;
                case /* c1.api.user.v1.User delegated_assignee_user */ 4:
                    message.delegatedAssigneeUser = User.internalBinaryRead(reader, reader.uint32(), options, message.delegatedAssigneeUser);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditReassignedToDelegate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string original_assignee_user_id = 1; */
        if (message.originalAssigneeUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.originalAssigneeUserId);
        /* string delegated_assignee_user_id = 2; */
        if (message.delegatedAssigneeUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.delegatedAssigneeUserId);
        /* c1.api.user.v1.User original_assignee_user = 3; */
        if (message.originalAssigneeUser)
            User.internalBinaryWrite(message.originalAssigneeUser, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.User delegated_assignee_user = 4; */
        if (message.delegatedAssigneeUser)
            User.internalBinaryWrite(message.delegatedAssigneeUser, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditReassignedToDelegate
 */
export const TaskAuditReassignedToDelegate = new TaskAuditReassignedToDelegate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditRestart$Type extends MessageType<TaskAuditRestart> {
    constructor() {
        super("c1.api.task.v1.TaskAuditRestart", [
            { no: 1, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditRestart>): TaskAuditRestart {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.oldPolicyStepId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditRestart>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditRestart): TaskAuditRestart {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string old_policy_step_id */ 1:
                    message.oldPolicyStepId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditRestart, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string old_policy_step_id = 1; */
        if (message.oldPolicyStepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.oldPolicyStepId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditRestart
 */
export const TaskAuditRestart = new TaskAuditRestart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditHardReset$Type extends MessageType<TaskAuditHardReset> {
    constructor() {
        super("c1.api.task.v1.TaskAuditHardReset", [
            { no: 1, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditHardReset>): TaskAuditHardReset {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.oldPolicyStepId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditHardReset>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditHardReset): TaskAuditHardReset {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string old_policy_step_id */ 1:
                    message.oldPolicyStepId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditHardReset, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string old_policy_step_id = 1; */
        if (message.oldPolicyStepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.oldPolicyStepId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditHardReset
 */
export const TaskAuditHardReset = new TaskAuditHardReset$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditEscalateToEmergencyAccess$Type extends MessageType<TaskAuditEscalateToEmergencyAccess> {
    constructor() {
        super("c1.api.task.v1.TaskAuditEscalateToEmergencyAccess", [
            { no: 1, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "old_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditEscalateToEmergencyAccess>): TaskAuditEscalateToEmergencyAccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.oldPolicyStepId = "";
        message.oldPolicyId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditEscalateToEmergencyAccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditEscalateToEmergencyAccess): TaskAuditEscalateToEmergencyAccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string old_policy_step_id */ 1:
                    message.oldPolicyStepId = reader.string();
                    break;
                case /* string old_policy_id */ 2:
                    message.oldPolicyId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditEscalateToEmergencyAccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string old_policy_step_id = 1; */
        if (message.oldPolicyStepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.oldPolicyStepId);
        /* string old_policy_id = 2; */
        if (message.oldPolicyId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.oldPolicyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditEscalateToEmergencyAccess
 */
export const TaskAuditEscalateToEmergencyAccess = new TaskAuditEscalateToEmergencyAccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditConditionalPolicyExecutionResult$Type extends MessageType<TaskAuditConditionalPolicyExecutionResult> {
    constructor() {
        super("c1.api.task.v1.TaskAuditConditionalPolicyExecutionResult", [
            { no: 1, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "policy_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "condition_matched", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "default_condition", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditConditionalPolicyExecutionResult>): TaskAuditConditionalPolicyExecutionResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.condition = "";
        message.policyKey = "";
        message.conditionMatched = false;
        message.defaultCondition = false;
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditConditionalPolicyExecutionResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditConditionalPolicyExecutionResult): TaskAuditConditionalPolicyExecutionResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string condition */ 1:
                    message.condition = reader.string();
                    break;
                case /* string policy_key */ 2:
                    message.policyKey = reader.string();
                    break;
                case /* bool condition_matched */ 3:
                    message.conditionMatched = reader.bool();
                    break;
                case /* bool default_condition */ 4:
                    message.defaultCondition = reader.bool();
                    break;
                case /* string error */ 5:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditConditionalPolicyExecutionResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string condition = 1; */
        if (message.condition !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.condition);
        /* string policy_key = 2; */
        if (message.policyKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.policyKey);
        /* bool condition_matched = 3; */
        if (message.conditionMatched !== false)
            writer.tag(3, WireType.Varint).bool(message.conditionMatched);
        /* bool default_condition = 4; */
        if (message.defaultCondition !== false)
            writer.tag(4, WireType.Varint).bool(message.defaultCondition);
        /* string error = 5; */
        if (message.error !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditConditionalPolicyExecutionResult
 */
export const TaskAuditConditionalPolicyExecutionResult = new TaskAuditConditionalPolicyExecutionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditExpressionPolicyStepError$Type extends MessageType<TaskAuditExpressionPolicyStepError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditExpressionPolicyStepError", [
            { no: 1, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditExpressionPolicyStepError>): TaskAuditExpressionPolicyStepError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditExpressionPolicyStepError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditExpressionPolicyStepError): TaskAuditExpressionPolicyStepError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string error */ 1:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditExpressionPolicyStepError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string error = 1; */
        if (message.error !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditExpressionPolicyStepError
 */
export const TaskAuditExpressionPolicyStepError = new TaskAuditExpressionPolicyStepError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditBulkActionError$Type extends MessageType<TaskAuditBulkActionError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditBulkActionError", [
            { no: 1, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditBulkActionError>): TaskAuditBulkActionError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditBulkActionError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditBulkActionError): TaskAuditBulkActionError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string error */ 1:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditBulkActionError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string error = 1; */
        if (message.error !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditBulkActionError
 */
export const TaskAuditBulkActionError = new TaskAuditBulkActionError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditExternalTicketTriggered$Type extends MessageType<TaskAuditExternalTicketTriggered> {
    constructor() {
        super("c1.api.task.v1.TaskAuditExternalTicketTriggered", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_ticket_provisioner_config_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditExternalTicketTriggered>): TaskAuditExternalTicketTriggered {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.externalTicketProvisionerConfigId = "";
        message.externalTicketId = "";
        message.externalTicketProvisionerConfigName = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditExternalTicketTriggered>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditExternalTicketTriggered): TaskAuditExternalTicketTriggered {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string external_ticket_provisioner_config_id */ 3:
                    message.externalTicketProvisionerConfigId = reader.string();
                    break;
                case /* string external_ticket_id */ 4:
                    message.externalTicketId = reader.string();
                    break;
                case /* string external_ticket_provisioner_config_name */ 5:
                    message.externalTicketProvisionerConfigName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditExternalTicketTriggered, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string external_ticket_provisioner_config_id = 3; */
        if (message.externalTicketProvisionerConfigId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalTicketProvisionerConfigId);
        /* string external_ticket_id = 4; */
        if (message.externalTicketId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalTicketId);
        /* string external_ticket_provisioner_config_name = 5; */
        if (message.externalTicketProvisionerConfigName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.externalTicketProvisionerConfigName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditExternalTicketTriggered
 */
export const TaskAuditExternalTicketTriggered = new TaskAuditExternalTicketTriggered$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditExternalTicketCreated$Type extends MessageType<TaskAuditExternalTicketCreated> {
    constructor() {
        super("c1.api.task.v1.TaskAuditExternalTicketCreated", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_ticket_provisioner_config_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "external_ticket_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditExternalTicketCreated>): TaskAuditExternalTicketCreated {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.externalTicketProvisionerConfigId = "";
        message.externalTicketId = "";
        message.externalTicketProvisionerConfigName = "";
        message.externalTicketUrl = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditExternalTicketCreated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditExternalTicketCreated): TaskAuditExternalTicketCreated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string external_ticket_provisioner_config_id */ 3:
                    message.externalTicketProvisionerConfigId = reader.string();
                    break;
                case /* string external_ticket_id */ 4:
                    message.externalTicketId = reader.string();
                    break;
                case /* string external_ticket_provisioner_config_name */ 5:
                    message.externalTicketProvisionerConfigName = reader.string();
                    break;
                case /* string external_ticket_url */ 6:
                    message.externalTicketUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditExternalTicketCreated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string external_ticket_provisioner_config_id = 3; */
        if (message.externalTicketProvisionerConfigId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalTicketProvisionerConfigId);
        /* string external_ticket_id = 4; */
        if (message.externalTicketId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalTicketId);
        /* string external_ticket_provisioner_config_name = 5; */
        if (message.externalTicketProvisionerConfigName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.externalTicketProvisionerConfigName);
        /* string external_ticket_url = 6; */
        if (message.externalTicketUrl !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.externalTicketUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditExternalTicketCreated
 */
export const TaskAuditExternalTicketCreated = new TaskAuditExternalTicketCreated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditExternalTicketProvisionStepResolved$Type extends MessageType<TaskAuditExternalTicketProvisionStepResolved> {
    constructor() {
        super("c1.api.task.v1.TaskAuditExternalTicketProvisionStepResolved", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_ticket_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditExternalTicketProvisionStepResolved>): TaskAuditExternalTicketProvisionStepResolved {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.externalTicketProvisionerConfigId = "";
        message.externalTicketId = "";
        message.externalTicketUrl = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditExternalTicketProvisionStepResolved>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditExternalTicketProvisionStepResolved): TaskAuditExternalTicketProvisionStepResolved {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string external_ticket_provisioner_config_id */ 3:
                    message.externalTicketProvisionerConfigId = reader.string();
                    break;
                case /* string external_ticket_id */ 4:
                    message.externalTicketId = reader.string();
                    break;
                case /* string external_ticket_url */ 5:
                    message.externalTicketUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditExternalTicketProvisionStepResolved, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string external_ticket_provisioner_config_id = 3; */
        if (message.externalTicketProvisionerConfigId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalTicketProvisionerConfigId);
        /* string external_ticket_id = 4; */
        if (message.externalTicketId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalTicketId);
        /* string external_ticket_url = 5; */
        if (message.externalTicketUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.externalTicketUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditExternalTicketProvisionStepResolved
 */
export const TaskAuditExternalTicketProvisionStepResolved = new TaskAuditExternalTicketProvisionStepResolved$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditExternalTicketError$Type extends MessageType<TaskAuditExternalTicketError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditExternalTicketError", [
            { no: 1, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditExternalTicketError>): TaskAuditExternalTicketError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditExternalTicketError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditExternalTicketError): TaskAuditExternalTicketError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string error_message */ 1:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditExternalTicketError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string error_message = 1; */
        if (message.errorMessage !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditExternalTicketError
 */
export const TaskAuditExternalTicketError = new TaskAuditExternalTicketError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookTriggered$Type extends MessageType<TaskAuditWebhookTriggered> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookTriggered", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWebhookTriggered>): TaskAuditWebhookTriggered {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.webhookUrl = "";
        message.webhookName = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWebhookTriggered>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWebhookTriggered): TaskAuditWebhookTriggered {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* string webhook_url */ 3:
                    message.webhookUrl = reader.string();
                    break;
                case /* string webhook_name */ 4:
                    message.webhookName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWebhookTriggered, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* string webhook_url = 3; */
        if (message.webhookUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.webhookUrl);
        /* string webhook_name = 4; */
        if (message.webhookName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.webhookName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookTriggered
 */
export const TaskAuditWebhookTriggered = new TaskAuditWebhookTriggered$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookAttempt$Type extends MessageType<TaskAuditWebhookAttempt> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookAttempt", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWebhookAttempt>): TaskAuditWebhookAttempt {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.webhookUrl = "";
        message.webhookName = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWebhookAttempt>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWebhookAttempt): TaskAuditWebhookAttempt {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* string webhook_url */ 3:
                    message.webhookUrl = reader.string();
                    break;
                case /* string webhook_name */ 4:
                    message.webhookName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWebhookAttempt, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* string webhook_url = 3; */
        if (message.webhookUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.webhookUrl);
        /* string webhook_name = 4; */
        if (message.webhookName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.webhookName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookAttempt
 */
export const TaskAuditWebhookAttempt = new TaskAuditWebhookAttempt$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookSuccess$Type extends MessageType<TaskAuditWebhookSuccess> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookSuccess", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWebhookSuccess>): TaskAuditWebhookSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.webhookUrl = "";
        message.webhookName = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWebhookSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWebhookSuccess): TaskAuditWebhookSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* string webhook_url */ 3:
                    message.webhookUrl = reader.string();
                    break;
                case /* string webhook_name */ 4:
                    message.webhookName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWebhookSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* string webhook_url = 3; */
        if (message.webhookUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.webhookUrl);
        /* string webhook_name = 4; */
        if (message.webhookName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.webhookName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookSuccess
 */
export const TaskAuditWebhookSuccess = new TaskAuditWebhookSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookApprovalTriggered$Type extends MessageType<TaskAuditWebhookApprovalTriggered> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookApprovalTriggered", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWebhookApprovalTriggered>): TaskAuditWebhookApprovalTriggered {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.webhookUrl = "";
        message.webhookName = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWebhookApprovalTriggered>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWebhookApprovalTriggered): TaskAuditWebhookApprovalTriggered {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* string webhook_url */ 3:
                    message.webhookUrl = reader.string();
                    break;
                case /* string webhook_name */ 4:
                    message.webhookName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWebhookApprovalTriggered, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* string webhook_url = 3; */
        if (message.webhookUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.webhookUrl);
        /* string webhook_name = 4; */
        if (message.webhookName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.webhookName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookApprovalTriggered
 */
export const TaskAuditWebhookApprovalTriggered = new TaskAuditWebhookApprovalTriggered$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookApprovalAttempt$Type extends MessageType<TaskAuditWebhookApprovalAttempt> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookApprovalAttempt", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWebhookApprovalAttempt>): TaskAuditWebhookApprovalAttempt {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.webhookUrl = "";
        message.webhookName = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWebhookApprovalAttempt>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWebhookApprovalAttempt): TaskAuditWebhookApprovalAttempt {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* string webhook_url */ 3:
                    message.webhookUrl = reader.string();
                    break;
                case /* string webhook_name */ 4:
                    message.webhookName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWebhookApprovalAttempt, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* string webhook_url = 3; */
        if (message.webhookUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.webhookUrl);
        /* string webhook_name = 4; */
        if (message.webhookName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.webhookName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookApprovalAttempt
 */
export const TaskAuditWebhookApprovalAttempt = new TaskAuditWebhookApprovalAttempt$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookApprovalSuccess$Type extends MessageType<TaskAuditWebhookApprovalSuccess> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookApprovalSuccess", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWebhookApprovalSuccess>): TaskAuditWebhookApprovalSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.webhookUrl = "";
        message.webhookName = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWebhookApprovalSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWebhookApprovalSuccess): TaskAuditWebhookApprovalSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* string webhook_url */ 3:
                    message.webhookUrl = reader.string();
                    break;
                case /* string webhook_name */ 4:
                    message.webhookName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWebhookApprovalSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* string webhook_url = 3; */
        if (message.webhookUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.webhookUrl);
        /* string webhook_name = 4; */
        if (message.webhookName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.webhookName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookApprovalSuccess
 */
export const TaskAuditWebhookApprovalSuccess = new TaskAuditWebhookApprovalSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookApprovalBadResponse$Type extends MessageType<TaskAuditWebhookApprovalBadResponse> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookApprovalBadResponse", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWebhookApprovalBadResponse>): TaskAuditWebhookApprovalBadResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.webhookUrl = "";
        message.webhookName = "";
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWebhookApprovalBadResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWebhookApprovalBadResponse): TaskAuditWebhookApprovalBadResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* string webhook_url */ 3:
                    message.webhookUrl = reader.string();
                    break;
                case /* string webhook_name */ 4:
                    message.webhookName = reader.string();
                    break;
                case /* string error */ 5:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWebhookApprovalBadResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* string webhook_url = 3; */
        if (message.webhookUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.webhookUrl);
        /* string webhook_name = 4; */
        if (message.webhookName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.webhookName);
        /* string error = 5; */
        if (message.error !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookApprovalBadResponse
 */
export const TaskAuditWebhookApprovalBadResponse = new TaskAuditWebhookApprovalBadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookApprovalFatalError$Type extends MessageType<TaskAuditWebhookApprovalFatalError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookApprovalFatalError", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWebhookApprovalFatalError>): TaskAuditWebhookApprovalFatalError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.webhookUrl = "";
        message.webhookName = "";
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWebhookApprovalFatalError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWebhookApprovalFatalError): TaskAuditWebhookApprovalFatalError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* string webhook_url */ 3:
                    message.webhookUrl = reader.string();
                    break;
                case /* string webhook_name */ 4:
                    message.webhookName = reader.string();
                    break;
                case /* string error */ 5:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWebhookApprovalFatalError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* string webhook_url = 3; */
        if (message.webhookUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.webhookUrl);
        /* string webhook_name = 4; */
        if (message.webhookName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.webhookName);
        /* string error = 5; */
        if (message.error !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookApprovalFatalError
 */
export const TaskAuditWebhookApprovalFatalError = new TaskAuditWebhookApprovalFatalError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyEvaluationStep$Type extends MessageType<TaskAuditPolicyEvaluationStep> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyEvaluationStep", [
            { no: 1, name: "step_comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditPolicyEvaluationStep>): TaskAuditPolicyEvaluationStep {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepComment = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditPolicyEvaluationStep>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditPolicyEvaluationStep): TaskAuditPolicyEvaluationStep {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_comment */ 1:
                    message.stepComment = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditPolicyEvaluationStep, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_comment = 1; */
        if (message.stepComment !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepComment);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyEvaluationStep
 */
export const TaskAuditPolicyEvaluationStep = new TaskAuditPolicyEvaluationStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitStepSuccess$Type extends MessageType<TaskAuditWaitStepSuccess> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitStepSuccess", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "succeeded_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWaitStepSuccess>): TaskAuditWaitStepSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepId = "";
        message.condition = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWaitStepSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWaitStepSuccess): TaskAuditWaitStepSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_id */ 1:
                    message.stepId = reader.string();
                    break;
                case /* string condition */ 2:
                    message.condition = reader.string();
                    break;
                case /* google.protobuf.Timestamp succeeded_at */ 3:
                    message.succeededAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.succeededAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWaitStepSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_id = 1; */
        if (message.stepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepId);
        /* string condition = 2; */
        if (message.condition !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.condition);
        /* google.protobuf.Timestamp succeeded_at = 3; */
        if (message.succeededAt)
            Timestamp.internalBinaryWrite(message.succeededAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitStepSuccess
 */
export const TaskAuditWaitStepSuccess = new TaskAuditWaitStepSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitStepWaiting$Type extends MessageType<TaskAuditWaitStepWaiting> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitStepWaiting", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWaitStepWaiting>): TaskAuditWaitStepWaiting {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepId = "";
        message.condition = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWaitStepWaiting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWaitStepWaiting): TaskAuditWaitStepWaiting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_id */ 1:
                    message.stepId = reader.string();
                    break;
                case /* string condition */ 2:
                    message.condition = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWaitStepWaiting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_id = 1; */
        if (message.stepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepId);
        /* string condition = 2; */
        if (message.condition !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.condition);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitStepWaiting
 */
export const TaskAuditWaitStepWaiting = new TaskAuditWaitStepWaiting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitStepTimedOut$Type extends MessageType<TaskAuditWaitStepTimedOut> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitStepTimedOut", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timed_out_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWaitStepTimedOut>): TaskAuditWaitStepTimedOut {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepId = "";
        message.condition = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWaitStepTimedOut>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWaitStepTimedOut): TaskAuditWaitStepTimedOut {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_id */ 1:
                    message.stepId = reader.string();
                    break;
                case /* string condition */ 2:
                    message.condition = reader.string();
                    break;
                case /* google.protobuf.Timestamp timed_out_at */ 3:
                    message.timedOutAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timedOutAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWaitStepTimedOut, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_id = 1; */
        if (message.stepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepId);
        /* string condition = 2; */
        if (message.condition !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.condition);
        /* google.protobuf.Timestamp timed_out_at = 3; */
        if (message.timedOutAt)
            Timestamp.internalBinaryWrite(message.timedOutAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitStepTimedOut
 */
export const TaskAuditWaitStepTimedOut = new TaskAuditWaitStepTimedOut$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitForAnalysisStepSuccess$Type extends MessageType<TaskAuditWaitForAnalysisStepSuccess> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitForAnalysisStepSuccess", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "succeeded_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWaitForAnalysisStepSuccess>): TaskAuditWaitForAnalysisStepSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWaitForAnalysisStepSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWaitForAnalysisStepSuccess): TaskAuditWaitForAnalysisStepSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_id */ 1:
                    message.stepId = reader.string();
                    break;
                case /* google.protobuf.Timestamp succeeded_at */ 3:
                    message.succeededAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.succeededAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWaitForAnalysisStepSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_id = 1; */
        if (message.stepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepId);
        /* google.protobuf.Timestamp succeeded_at = 3; */
        if (message.succeededAt)
            Timestamp.internalBinaryWrite(message.succeededAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepSuccess
 */
export const TaskAuditWaitForAnalysisStepSuccess = new TaskAuditWaitForAnalysisStepSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitForAnalysisStepWaiting$Type extends MessageType<TaskAuditWaitForAnalysisStepWaiting> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitForAnalysisStepWaiting", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWaitForAnalysisStepWaiting>): TaskAuditWaitForAnalysisStepWaiting {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWaitForAnalysisStepWaiting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWaitForAnalysisStepWaiting): TaskAuditWaitForAnalysisStepWaiting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_id */ 1:
                    message.stepId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWaitForAnalysisStepWaiting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_id = 1; */
        if (message.stepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepWaiting
 */
export const TaskAuditWaitForAnalysisStepWaiting = new TaskAuditWaitForAnalysisStepWaiting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitForAnalysisStepTimedOut$Type extends MessageType<TaskAuditWaitForAnalysisStepTimedOut> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitForAnalysisStepTimedOut", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timed_out_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWaitForAnalysisStepTimedOut>): TaskAuditWaitForAnalysisStepTimedOut {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWaitForAnalysisStepTimedOut>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWaitForAnalysisStepTimedOut): TaskAuditWaitForAnalysisStepTimedOut {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_id */ 1:
                    message.stepId = reader.string();
                    break;
                case /* google.protobuf.Timestamp timed_out_at */ 3:
                    message.timedOutAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timedOutAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWaitForAnalysisStepTimedOut, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_id = 1; */
        if (message.stepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepId);
        /* google.protobuf.Timestamp timed_out_at = 3; */
        if (message.timedOutAt)
            Timestamp.internalBinaryWrite(message.timedOutAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepTimedOut
 */
export const TaskAuditWaitForAnalysisStepTimedOut = new TaskAuditWaitForAnalysisStepTimedOut$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditSLAEscalation$Type extends MessageType<TaskAuditSLAEscalation> {
    constructor() {
        super("c1.api.task.v1.TaskAuditSLAEscalation", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditSLAEscalation>): TaskAuditSLAEscalation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditSLAEscalation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditSLAEscalation): TaskAuditSLAEscalation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string message */ 1:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditSLAEscalation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string message = 1; */
        if (message.message !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditSLAEscalation
 */
export const TaskAuditSLAEscalation = new TaskAuditSLAEscalation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyChanged$Type extends MessageType<TaskAuditPolicyChanged> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyChanged", [
            { no: 1, name: "old_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditPolicyChanged>): TaskAuditPolicyChanged {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.oldPolicyId = "";
        message.newPolicyId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditPolicyChanged>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditPolicyChanged): TaskAuditPolicyChanged {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string old_policy_id */ 1:
                    message.oldPolicyId = reader.string();
                    break;
                case /* string new_policy_id */ 2:
                    message.newPolicyId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditPolicyChanged, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string old_policy_id = 1; */
        if (message.oldPolicyId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.oldPolicyId);
        /* string new_policy_id = 2; */
        if (message.newPolicyId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.newPolicyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyChanged
 */
export const TaskAuditPolicyChanged = new TaskAuditPolicyChanged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditFormInstanceChange$Type extends MessageType<TaskAuditFormInstanceChange> {
    constructor() {
        super("c1.api.task.v1.TaskAuditFormInstanceChange", [
            { no: 1, name: "is_valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditFormInstanceChange>): TaskAuditFormInstanceChange {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isValid = false;
        if (value !== undefined)
            reflectionMergePartial<TaskAuditFormInstanceChange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditFormInstanceChange): TaskAuditFormInstanceChange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_valid */ 1:
                    message.isValid = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditFormInstanceChange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_valid = 1; */
        if (message.isValid !== false)
            writer.tag(1, WireType.Varint).bool(message.isValid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditFormInstanceChange
 */
export const TaskAuditFormInstanceChange = new TaskAuditFormInstanceChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditGrantDurationUpdated$Type extends MessageType<TaskAuditGrantDurationUpdated> {
    constructor() {
        super("c1.api.task.v1.TaskAuditGrantDurationUpdated", [
            { no: 1, name: "duration", kind: "message", T: () => Duration }
        ]);
    }
    create(value?: PartialMessage<TaskAuditGrantDurationUpdated>): TaskAuditGrantDurationUpdated {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditGrantDurationUpdated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditGrantDurationUpdated): TaskAuditGrantDurationUpdated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration duration */ 1:
                    message.duration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.duration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditGrantDurationUpdated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration duration = 1; */
        if (message.duration)
            Duration.internalBinaryWrite(message.duration, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditGrantDurationUpdated
 */
export const TaskAuditGrantDurationUpdated = new TaskAuditGrantDurationUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitStepUntilTime$Type extends MessageType<TaskAuditWaitStepUntilTime> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitStepUntilTime", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "until_time", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWaitStepUntilTime>): TaskAuditWaitStepUntilTime {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWaitStepUntilTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWaitStepUntilTime): TaskAuditWaitStepUntilTime {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_id */ 1:
                    message.stepId = reader.string();
                    break;
                case /* google.protobuf.Timestamp until_time */ 2:
                    message.untilTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.untilTime);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWaitStepUntilTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_id = 1; */
        if (message.stepId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepId);
        /* google.protobuf.Timestamp until_time = 2; */
        if (message.untilTime)
            Timestamp.internalBinaryWrite(message.untilTime, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitStepUntilTime
 */
export const TaskAuditWaitStepUntilTime = new TaskAuditWaitStepUntilTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditAccountLifecycleActionCreated$Type extends MessageType<TaskAuditAccountLifecycleActionCreated> {
    constructor() {
        super("c1.api.task.v1.TaskAuditAccountLifecycleActionCreated", [
            { no: 1, name: "baton_action_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "baton_action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "baton_connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "baton_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "baton_action_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditAccountLifecycleActionCreated>): TaskAuditAccountLifecycleActionCreated {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.batonActionInvocationId = "";
        message.batonActionName = "";
        message.batonConnectorId = "";
        message.batonAppId = "";
        message.batonActionDisplayName = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditAccountLifecycleActionCreated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditAccountLifecycleActionCreated): TaskAuditAccountLifecycleActionCreated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string baton_action_invocation_id */ 1:
                    message.batonActionInvocationId = reader.string();
                    break;
                case /* string baton_action_name */ 2:
                    message.batonActionName = reader.string();
                    break;
                case /* string baton_connector_id */ 3:
                    message.batonConnectorId = reader.string();
                    break;
                case /* string baton_app_id */ 4:
                    message.batonAppId = reader.string();
                    break;
                case /* string baton_action_display_name */ 5:
                    message.batonActionDisplayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditAccountLifecycleActionCreated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string baton_action_invocation_id = 1; */
        if (message.batonActionInvocationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.batonActionInvocationId);
        /* string baton_action_name = 2; */
        if (message.batonActionName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.batonActionName);
        /* string baton_connector_id = 3; */
        if (message.batonConnectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.batonConnectorId);
        /* string baton_app_id = 4; */
        if (message.batonAppId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.batonAppId);
        /* string baton_action_display_name = 5; */
        if (message.batonActionDisplayName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.batonActionDisplayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditAccountLifecycleActionCreated
 */
export const TaskAuditAccountLifecycleActionCreated = new TaskAuditAccountLifecycleActionCreated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditAccountLifecycleActionFailed$Type extends MessageType<TaskAuditAccountLifecycleActionFailed> {
    constructor() {
        super("c1.api.task.v1.TaskAuditAccountLifecycleActionFailed", [
            { no: 1, name: "baton_action_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "baton_action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "baton_connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "baton_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "baton_action_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditAccountLifecycleActionFailed>): TaskAuditAccountLifecycleActionFailed {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.batonActionInvocationId = "";
        message.batonActionName = "";
        message.batonConnectorId = "";
        message.batonAppId = "";
        message.batonActionDisplayName = "";
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditAccountLifecycleActionFailed>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditAccountLifecycleActionFailed): TaskAuditAccountLifecycleActionFailed {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string baton_action_invocation_id */ 1:
                    message.batonActionInvocationId = reader.string();
                    break;
                case /* string baton_action_name */ 2:
                    message.batonActionName = reader.string();
                    break;
                case /* string baton_connector_id */ 3:
                    message.batonConnectorId = reader.string();
                    break;
                case /* string baton_app_id */ 4:
                    message.batonAppId = reader.string();
                    break;
                case /* string baton_action_display_name */ 5:
                    message.batonActionDisplayName = reader.string();
                    break;
                case /* string error */ 6:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditAccountLifecycleActionFailed, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string baton_action_invocation_id = 1; */
        if (message.batonActionInvocationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.batonActionInvocationId);
        /* string baton_action_name = 2; */
        if (message.batonActionName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.batonActionName);
        /* string baton_connector_id = 3; */
        if (message.batonConnectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.batonConnectorId);
        /* string baton_app_id = 4; */
        if (message.batonAppId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.batonAppId);
        /* string baton_action_display_name = 5; */
        if (message.batonActionDisplayName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.batonActionDisplayName);
        /* string error = 6; */
        if (message.error !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditAccountLifecycleActionFailed
 */
export const TaskAuditAccountLifecycleActionFailed = new TaskAuditAccountLifecycleActionFailed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyProvisionCancelled$Type extends MessageType<TaskAuditPolicyProvisionCancelled> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyProvisionCancelled", [
            { no: 1, name: "cancel_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditPolicyProvisionCancelled>): TaskAuditPolicyProvisionCancelled {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cancelReason = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditPolicyProvisionCancelled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditPolicyProvisionCancelled): TaskAuditPolicyProvisionCancelled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string cancel_reason */ 1:
                    message.cancelReason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditPolicyProvisionCancelled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string cancel_reason = 1; */
        if (message.cancelReason !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.cancelReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyProvisionCancelled
 */
export const TaskAuditPolicyProvisionCancelled = new TaskAuditPolicyProvisionCancelled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditCreatedReplacementExtensionGrantTask$Type extends MessageType<TaskAuditCreatedReplacementExtensionGrantTask> {
    constructor() {
        super("c1.api.task.v1.TaskAuditCreatedReplacementExtensionGrantTask", [
            { no: 1, name: "new_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_task_numeric_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditCreatedReplacementExtensionGrantTask>): TaskAuditCreatedReplacementExtensionGrantTask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.newTaskId = "";
        message.newTaskNumericId = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskAuditCreatedReplacementExtensionGrantTask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditCreatedReplacementExtensionGrantTask): TaskAuditCreatedReplacementExtensionGrantTask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string new_task_id */ 1:
                    message.newTaskId = reader.string();
                    break;
                case /* int64 new_task_numeric_id */ 2:
                    message.newTaskNumericId = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditCreatedReplacementExtensionGrantTask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string new_task_id = 1; */
        if (message.newTaskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.newTaskId);
        /* int64 new_task_numeric_id = 2; */
        if (message.newTaskNumericId !== 0)
            writer.tag(2, WireType.Varint).int64(message.newTaskNumericId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditCreatedReplacementExtensionGrantTask
 */
export const TaskAuditCreatedReplacementExtensionGrantTask = new TaskAuditCreatedReplacementExtensionGrantTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditNewTaskCreatedFrom$Type extends MessageType<TaskAuditNewTaskCreatedFrom> {
    constructor() {
        super("c1.api.task.v1.TaskAuditNewTaskCreatedFrom", [
            { no: 1, name: "original_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "original_task_numeric_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditNewTaskCreatedFrom>): TaskAuditNewTaskCreatedFrom {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.originalTaskId = "";
        message.originalTaskNumericId = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskAuditNewTaskCreatedFrom>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditNewTaskCreatedFrom): TaskAuditNewTaskCreatedFrom {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string original_task_id */ 1:
                    message.originalTaskId = reader.string();
                    break;
                case /* int64 original_task_numeric_id */ 2:
                    message.originalTaskNumericId = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditNewTaskCreatedFrom, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string original_task_id = 1; */
        if (message.originalTaskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.originalTaskId);
        /* int64 original_task_numeric_id = 2; */
        if (message.originalTaskNumericId !== 0)
            writer.tag(2, WireType.Varint).int64(message.originalTaskNumericId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditNewTaskCreatedFrom
 */
export const TaskAuditNewTaskCreatedFrom = new TaskAuditNewTaskCreatedFrom$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditReassignmentFallbackToAdmin$Type extends MessageType<TaskAuditReassignmentFallbackToAdmin> {
    constructor() {
        super("c1.api.task.v1.TaskAuditReassignmentFallbackToAdmin", [
            { no: 1, name: "admin_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "admin_users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<TaskAuditReassignmentFallbackToAdmin>): TaskAuditReassignmentFallbackToAdmin {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.adminUserIds = [];
        message.adminUsers = [];
        if (value !== undefined)
            reflectionMergePartial<TaskAuditReassignmentFallbackToAdmin>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditReassignmentFallbackToAdmin): TaskAuditReassignmentFallbackToAdmin {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string admin_user_ids */ 1:
                    message.adminUserIds.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.User admin_users */ 2:
                    message.adminUsers.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditReassignmentFallbackToAdmin, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string admin_user_ids = 1; */
        for (let i = 0; i < message.adminUserIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.adminUserIds[i]);
        /* repeated c1.api.user.v1.User admin_users = 2; */
        for (let i = 0; i < message.adminUsers.length; i++)
            User.internalBinaryWrite(message.adminUsers[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditReassignmentFallbackToAdmin
 */
export const TaskAuditReassignmentFallbackToAdmin = new TaskAuditReassignmentFallbackToAdmin$Type();
/**
 * @generated ServiceType for protobuf service c1.api.task.v1.TaskAudit
 */
export const TaskAudit = new ServiceType("c1.api.task.v1.TaskAudit", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/task/audits", group: "Task" }] } }, I: TaskAuditListRequest, O: TaskAuditListResponse }
]);
